export const iconMetadata: Array<{ 
  name: string; 
  category: string; 
  tags: string[]; 
  filename: string; 
  width: number | null;
  height: number | null;
}> = [
  {
    "name": "Workspace",
    "filename": "workspace.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "file",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceUpload",
    "filename": "workspace-upload.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "arrow",
      "up",
      "data",
      "upload"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceTemplate",
    "filename": "workspace-template.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "template",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceTemplateRemove",
    "filename": "workspace-template-remove.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceTemplateEdit",
    "filename": "workspace-template-edit.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceTemplateConvert",
    "filename": "workspace-template-convert.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "convert",
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceTemplateAdd",
    "filename": "workspace-template-add.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "plus",
      "create",
      "add",
      "template"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceSettings",
    "filename": "workspace-settings.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceDownload",
    "filename": "workspace-download.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "arrow",
      "down",
      "data",
      "download"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceDelete",
    "filename": "workspace-delete.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkspaceAdd",
    "filename": "workspace-add.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ModuleWorkflow",
    "filename": "module-workflow.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "module",
      "workflow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ModuleForms",
    "filename": "module-forms.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "module",
      "forms",
      "survey"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ModuleDatasheets",
    "filename": "module-datasheets.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "module",
      "datasheets",
      "table",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ModuleCharts",
    "filename": "module-charts.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "module",
      "charts",
      "bar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Appearance",
    "filename": "appearance.svg",
    "category": "workspaces",
    "tags": [
      "workspaces",
      "sidebar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WelcomeWorkflow",
    "filename": "welcome-workflow.svg",
    "category": "welcome",
    "tags": [
      "welcome",
      "choiceform",
      "tx",
      "workflow"
    ],
    "width": 32,
    "height": 32
  },
  {
    "name": "WelcomeInterface",
    "filename": "welcome-interface.svg",
    "category": "welcome",
    "tags": [
      "welcome",
      "choiceform",
      "tx",
      "interface"
    ],
    "width": 32,
    "height": 32
  },
  {
    "name": "WelcomeForms",
    "filename": "welcome-forms.svg",
    "category": "welcome",
    "tags": [
      "welcome",
      "choiceform",
      "tx",
      "forms"
    ],
    "width": 32,
    "height": 32
  },
  {
    "name": "WelcomeExtension",
    "filename": "welcome-extension.svg",
    "category": "welcome",
    "tags": [
      "welcome",
      "choiceform",
      "tx",
      "extension"
    ],
    "width": 32,
    "height": 32
  },
  {
    "name": "WelcomeDatasheets",
    "filename": "welcome-datasheets.svg",
    "category": "welcome",
    "tags": [
      "welcome",
      "choiceform",
      "tx",
      "datasheets"
    ],
    "width": 32,
    "height": 32
  },
  {
    "name": "WelcomeCharts",
    "filename": "welcome-charts.svg",
    "category": "welcome",
    "tags": [
      "welcome",
      "choiceform",
      "tx",
      "charts"
    ],
    "width": 32,
    "height": 32
  },
  {
    "name": "Wifi",
    "filename": "wifi.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WifiOff",
    "filename": "wifi-off.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CloudUpload",
    "filename": "cloud-upload.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network",
      "weather",
      "cloud",
      "file",
      "export",
      "upload"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CloudOff",
    "filename": "cloud-off.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network",
      "weather",
      "cloud"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CloudDownload",
    "filename": "cloud-download.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network",
      "weather",
      "cloud",
      "file",
      "import"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CloudCog",
    "filename": "cloud-cog.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network",
      "weather",
      "cloud",
      "settings"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CloudCheck",
    "filename": "cloud-check.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network",
      "weather",
      "cloud",
      "success",
      "done",
      "completed",
      "saved",
      "persisted"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CloudAlert",
    "filename": "cloud-alert.svg",
    "category": "sync",
    "tags": [
      "connection",
      "wireless",
      "sync",
      "network",
      "danger",
      "warning",
      "alert",
      "error"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkflowFile",
    "filename": "workflow-file.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkflowFileOutport",
    "filename": "workflow-file-outport.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "arrow",
      "right",
      "input",
      "import",
      "output"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkflowFileImport",
    "filename": "workflow-file-import.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "arrow",
      "right",
      "input",
      "import",
      "output"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkflowFileDelete",
    "filename": "workflow-file-delete.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WorkflowFileAdd",
    "filename": "workflow-file-add.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriggerStartedByWebhook",
    "filename": "trigger-started-by-webhook.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "trigger",
      "webhook"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriggerStartedByDateOrTimeField",
    "filename": "trigger-started-by-date-or-time-field.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "trigger",
      "calendar",
      "date",
      "time"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriggerStartedByAnEvent",
    "filename": "trigger-started-by-an-event.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "trigger",
      "datasheet"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriggerStartedByAButton",
    "filename": "trigger-started-by-a-button.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "trigger"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriggerStartedAtASpecificTime",
    "filename": "trigger-started-at-a-specific-time.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "trigger",
      "clock",
      "time",
      "date",
      "watch"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriggerConnectorEvent",
    "filename": "trigger-connector-event.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "trigger",
      "plug",
      "energy",
      "power"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarTrigger",
    "filename": "toolbar-trigger.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarAll",
    "filename": "toolbar-all.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarAction",
    "filename": "toolbar-action.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "toolbar",
      "lightning",
      "flash",
      "activity",
      "auto"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "System",
    "filename": "system.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "data",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RefreshError",
    "filename": "refresh-error.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "refresh",
      "lightning",
      "flash",
      "activity"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RefreshAll",
    "filename": "refresh-all.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "refresh",
      "auto"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ReferenceLine",
    "filename": "reference-line.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Publish",
    "filename": "publish.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "spaceship",
      "rocket",
      "space"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PlaySolid",
    "filename": "play-solid.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "nodes",
      "solid",
      "play",
      "triangle",
      "forward",
      "next",
      "control"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PinSolid",
    "filename": "pin-solid.svg",
    "category": "workflow",
    "tags": [
      "lock",
      "fix",
      "map",
      "save",
      "workflow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PbpOutput",
    "filename": "pbp-output.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "packaged",
      "arrow",
      "right",
      "import",
      "output",
      "volume",
      "axis",
      "dimension",
      "3d",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PbpInput",
    "filename": "pbp-input.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "packaged",
      "arrow",
      "right",
      "input",
      "import",
      "volume",
      "axis",
      "dimension",
      "3d",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Packaged",
    "filename": "packaged.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "packaged",
      "3d",
      "dimension",
      "axis",
      "volume",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PackagedOutport",
    "filename": "packaged-outport.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "packaged",
      "arrow",
      "right",
      "output",
      "volume",
      "axis",
      "dimension",
      "3d",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PackagedImport",
    "filename": "packaged-import.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "packaged",
      "arrow",
      "right",
      "input",
      "import",
      "volume",
      "axis",
      "dimension",
      "3d",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PackagedAdd",
    "filename": "packaged-add.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "packaged",
      "add",
      "create",
      "plus",
      "volume",
      "axis",
      "dimension",
      "3d",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "NodesTidy",
    "filename": "nodes-tidy.svg",
    "category": "workflow",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "MenuDotsSolid",
    "filename": "menu-dots-solid.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "menu",
      "dots",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "HistotyList",
    "filename": "histoty-list.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "histoty",
      "list",
      "bullets"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FitScreen",
    "filename": "fit-screen.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "screen",
      "expand",
      "maximize"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DuplicateSolid",
    "filename": "duplicate-solid.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "nodes",
      "solid",
      "duplicate",
      "copy",
      "clone",
      "paste"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DeactivateSolid",
    "filename": "deactivate-solid.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "nodes",
      "power",
      "off"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleUnpassedSolid",
    "filename": "circle-unpassed-solid.svg",
    "category": "workflow",
    "tags": [
      "circle",
      "solid",
      "control",
      "empty",
      "nothing"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleSuccessSolid",
    "filename": "circle-success-solid.svg",
    "category": "workflow",
    "tags": [
      "circle",
      "solid",
      "success",
      "select",
      "done",
      "checked",
      "tick",
      "completed",
      "choice",
      "control"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleSkipSolid",
    "filename": "circle-skip-solid.svg",
    "category": "workflow",
    "tags": [
      "circle",
      "solid",
      "arrow",
      "right",
      "control"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CirclePlaySolid",
    "filename": "circle-play-solid.svg",
    "category": "workflow",
    "tags": [
      "circle",
      "solid",
      "play",
      "triangle",
      "forward",
      "next",
      "control"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CirclePauseSolid",
    "filename": "circle-pause-solid.svg",
    "category": "workflow",
    "tags": [
      "circle",
      "solid",
      "pause",
      "control"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleErrorSolid",
    "filename": "circle-error-solid.svg",
    "category": "workflow",
    "tags": [
      "circle",
      "solid",
      "clear",
      "remove",
      "delete",
      "control"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Bolt",
    "filename": "bolt.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "lightning",
      "flash",
      "activity"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BoltSolid",
    "filename": "bolt-solid.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "solid",
      "lightning",
      "flash",
      "activity"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BinSolid",
    "filename": "bin-solid.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "nodes",
      "solid",
      "trash",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AutoLayout",
    "filename": "auto-layout.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "auto"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AddBranchSolid",
    "filename": "add-branch-solid.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "nodes",
      "solid",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionWebhook",
    "filename": "action-webhook.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionWaitForSomeTime",
    "filename": "action-wait-for-some-time.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "clock",
      "stopwatch",
      "watch",
      "time",
      "date"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionUpdateRecord",
    "filename": "action-update-record.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "record"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionPath",
    "filename": "action-path.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "list"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionPackagedNode",
    "filename": "action-packaged-node.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionNotification",
    "filename": "action-notification.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "megaphone",
      "update"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionIf",
    "filename": "action-if.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "if",
      "branch"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionHttpRequest",
    "filename": "action-http-request.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "url"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetSegmentFilters",
    "filename": "action-get-segment-filters.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "filter"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetRecordsFromWebhook",
    "filename": "action-get-records-from-webhook.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "webhook"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetRecordsFromLinkedRecords",
    "filename": "action-get-records-from-linked-records.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "arrow",
      "right",
      "input",
      "import",
      "output"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetRecordsFromCodeBlock",
    "filename": "action-get-records-from-code-block.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "record"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetRecordsFromANode",
    "filename": "action-get-records-from-a-node.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "record"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetRecordsFromADatasheet",
    "filename": "action-get-records-from-a-datasheet.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "from",
      "from"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetOneRecordFromLinkedRecords",
    "filename": "action-get-one-record-from-linked-records.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "arrow",
      "right",
      "input",
      "import",
      "output",
      "from",
      "from"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionGetOneRecordFromADatasheet",
    "filename": "action-get-one-record-from-a-datasheet.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "from",
      "from"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionFormulaNode",
    "filename": "action-formula-node.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "equation"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionDeleteRecord",
    "filename": "action-delete-record.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "clear",
      "remove",
      "delete",
      "record"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionDateNode",
    "filename": "action-date-node.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "dynamic",
      "calendar",
      "date",
      "time"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionCreateRecord",
    "filename": "action-create-record.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionConnectorRequestNode",
    "filename": "action-connector-request-node.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "dynamic",
      "plug",
      "energy",
      "power"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ActionCodeBlock",
    "filename": "action-code-block.svg",
    "category": "workflow",
    "tags": [
      "workflow",
      "action",
      "code",
      "development"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarWebSearch",
    "filename": "prompt-toolbar-web-search.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarWaiting",
    "filename": "prompt-toolbar-waiting.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarSubmit",
    "filename": "prompt-toolbar-submit.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarMic",
    "filename": "prompt-toolbar-mic.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarCancel",
    "filename": "prompt-toolbar-cancel.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarAudioLines",
    "filename": "prompt-toolbar-audio-lines.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarAttach",
    "filename": "prompt-toolbar-attach.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarAdd",
    "filename": "prompt-toolbar-add.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptToolbarAddQueue",
    "filename": "prompt-toolbar-add-queue.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptMessageTools",
    "filename": "prompt-message-tools.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "message"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptMessageSources",
    "filename": "prompt-message-sources.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "message"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptMessageReasoning",
    "filename": "prompt-message-reasoning.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "message"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptMessagePlanning",
    "filename": "prompt-message-planning.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "message"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptMessagePlan",
    "filename": "prompt-message-plan.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "message"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptActionsTrash",
    "filename": "prompt-actions-trash.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "actions"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptActionsThumbsUp",
    "filename": "prompt-actions-thumbs-up.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "actions"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptActionsThumbsDown",
    "filename": "prompt-actions-thumbs-down.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "actions"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptActionsRegenerate",
    "filename": "prompt-actions-regenerate.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "actions"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PromptActionsClipboard",
    "filename": "prompt-actions-clipboard.svg",
    "category": "prompt-kit",
    "tags": [
      "prompt-kit",
      "actions"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Wecom",
    "filename": "wecom.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "wecom",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WecomColor",
    "filename": "wecom-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "wecom",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Wechat",
    "filename": "wechat.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "wechat",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WechatPublic",
    "filename": "wechat-public.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "wechat",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TeamsColor",
    "filename": "teams-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "teams",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Slack",
    "filename": "slack.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "slack",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SlackColor",
    "filename": "slack-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "slack",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Google",
    "filename": "google.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "google",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GoogleDriveColor",
    "filename": "google-drive-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "google",
      "drive",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GoogleColor",
    "filename": "google-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "google",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Github",
    "filename": "github.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "github",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Feishu",
    "filename": "feishu.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "feishu",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FeishuColor",
    "filename": "feishu-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "feishu",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Dingding",
    "filename": "dingding.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "dingding",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DingdingColor",
    "filename": "dingding-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "dingding",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Choiceform",
    "filename": "choiceform.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "choiceform",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChoiceformColor",
    "filename": "choiceform-color.svg",
    "category": "logo",
    "tags": [
      "brand",
      "logo",
      "choiceform",
      "colourful",
      "color",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextUnderline",
    "filename": "text-underline.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextItalic",
    "filename": "text-italic.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextColor",
    "filename": "text-color.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "color",
      "style"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextBgColor",
    "filename": "text-bg-color.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "color",
      "style"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextAlignRight",
    "filename": "text-align-right.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextAlignLeft",
    "filename": "text-align-left.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextAlignJustify",
    "filename": "text-align-justify.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "justify"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextAlignCenter",
    "filename": "text-align-center.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "center"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphUnderline",
    "filename": "paragraph-underline.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphStrikethrough",
    "filename": "paragraph-strikethrough.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphRemoveFormatting",
    "filename": "paragraph-remove-formatting.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphQuote",
    "filename": "paragraph-quote.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphPilcrow",
    "filename": "paragraph-pilcrow.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphList",
    "filename": "paragraph-list.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphListTodo",
    "filename": "paragraph-list-todo.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphListOrdered",
    "filename": "paragraph-list-ordered.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphLink",
    "filename": "paragraph-link.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphLinkOff",
    "filename": "paragraph-link-off.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphItalic",
    "filename": "paragraph-italic.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHighlighter",
    "filename": "paragraph-highlighter.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHeading",
    "filename": "paragraph-heading.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHeading6",
    "filename": "paragraph-heading-6.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHeading5",
    "filename": "paragraph-heading-5.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHeading4",
    "filename": "paragraph-heading-4.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHeading3",
    "filename": "paragraph-heading-3.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHeading2",
    "filename": "paragraph-heading-2.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphHeading1",
    "filename": "paragraph-heading-1.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphCode",
    "filename": "paragraph-code.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphCodeBlock",
    "filename": "paragraph-code-block.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ParagraphBold",
    "filename": "paragraph-bold.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontUppercase",
    "filename": "font-uppercase.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontUnderlineSmall",
    "filename": "font-underline-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontTruncation",
    "filename": "font-truncation.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontStrikethroughSmall",
    "filename": "font-strikethrough-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontSmallCaps",
    "filename": "font-small-caps.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontSizeSmall",
    "filename": "font-size-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontParagraphSpacingSmall",
    "filename": "font-paragraph-spacing-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontNumberedSmall",
    "filename": "font-numbered-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "list"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontLowercase",
    "filename": "font-lowercase.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontLineHeightSmall",
    "filename": "font-line-height-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontLetterSpacingSmall",
    "filename": "font-letter-spacing-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontFixedSizeSmall",
    "filename": "font-fixed-size-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontColorSmall",
    "filename": "font-color-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "color",
      "style"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontClearFormatSmall",
    "filename": "font-clear-format-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontCapitalize",
    "filename": "font-capitalize.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontBulletedSmall",
    "filename": "font-bulleted-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "list"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontBoldSmall",
    "filename": "font-bold-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "bold",
      "weight"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontBackgroundSmall",
    "filename": "font-background-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "color",
      "style"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAutoWidthSmall",
    "filename": "font-auto-width-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAutoHeightSmall",
    "filename": "font-auto-height-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAlignTopSmall",
    "filename": "font-align-top-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "arrow",
      "top",
      "up"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAlignRightSmall",
    "filename": "font-align-right-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAlignMiddleSmall",
    "filename": "font-align-middle-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAlignLeftSmall",
    "filename": "font-align-left-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAlignJustifySmall",
    "filename": "font-align-justify-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "justify"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAlignCenterSmall",
    "filename": "font-align-center-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "center"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FontAlignBottomSmall",
    "filename": "font-align-bottom-small.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "align",
      "arrow",
      "down",
      "bottom"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Bold",
    "filename": "bold.svg",
    "category": "text-editing",
    "tags": [
      "text",
      "font",
      "type",
      "typography",
      "editing",
      "formatting",
      "bold",
      "weight"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningPublishFail",
    "filename": "warning-publish-fail.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "warning",
      "publish",
      "rocket",
      "space"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningNotFound",
    "filename": "warning-not-found.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "warning",
      "404"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningLinkExpired",
    "filename": "warning-link-expired.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "warning",
      "unlink",
      "broken",
      "link"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningFileBroken",
    "filename": "warning-file-broken.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "warning",
      "broken",
      "file",
      "page",
      "draft",
      "item",
      "document",
      "content",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyWorkspace",
    "filename": "empty-workspace.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "desk",
      "workspace",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyWorkflow",
    "filename": "empty-workflow.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "workflow",
      "intelligence"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyWorkflowNode",
    "filename": "empty-workflow-node.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "workflow",
      "network",
      "intelligence"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyUser",
    "filename": "empty-user.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyTrash",
    "filename": "empty-trash.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "trash",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptySurvey",
    "filename": "empty-survey.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "file",
      "document",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "data",
      "survey",
      "form"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptySort",
    "filename": "empty-sort.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "sort",
      "order",
      "filter"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptySearch",
    "filename": "empty-search.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "search",
      "find",
      "lookup",
      "explore",
      "magnifier",
      "question"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyOrganizations",
    "filename": "empty-organizations.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "organization",
      "team",
      "group",
      "building",
      "business",
      "company",
      "warning"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyNotifications",
    "filename": "empty-notifications.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "bell",
      "notification",
      "alarm",
      "buzz",
      "alert",
      "audio",
      "sound"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyNoAuthority",
    "filename": "empty-no-authority.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "lock",
      "locked",
      "secure",
      "password",
      "key",
      "safety",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyLogic",
    "filename": "empty-logic.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "branch",
      "logic",
      "merge",
      "commit"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyImage",
    "filename": "empty-image.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "image",
      "photo",
      "picture",
      "media",
      "gallery",
      "graphic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyGroup",
    "filename": "empty-group.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "group",
      "check"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyFolder",
    "filename": "empty-folder.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "folder",
      "directory",
      "folder-open",
      "file",
      "catalog"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyFilter",
    "filename": "empty-filter.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "filter",
      "funnel",
      "search"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyFile",
    "filename": "empty-file.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyDynamic",
    "filename": "empty-dynamic.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "sign",
      "inbox",
      "email",
      "dynamic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyDatabase",
    "filename": "empty-database.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "database",
      "hosting",
      "server",
      "hardware"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyData",
    "filename": "empty-data.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "data",
      "archive",
      "storage"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyConnector",
    "filename": "empty-connector.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "connector",
      "connect",
      "link"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmptyChart",
    "filename": "empty-chart.svg",
    "category": "flash-screen",
    "tags": [
      "flash-screen",
      "empty",
      "bar",
      "chart",
      "diagram"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Folder",
    "filename": "folder.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderSettings",
    "filename": "folder-settings.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderRemove",
    "filename": "folder-remove.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "delete",
      "remove",
      "close",
      "exit",
      "cancel",
      "discard"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderPlus",
    "filename": "folder-plus.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderPen",
    "filename": "folder-pen.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderOpen",
    "filename": "folder-open.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "open",
      "archive"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderLock",
    "filename": "folder-lock.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "lock",
      "security",
      "safe",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderInput",
    "filename": "folder-input.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "arrow",
      "right",
      "data",
      "import",
      "input"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderDelete",
    "filename": "folder-delete.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "clear",
      "delete",
      "remove",
      "close",
      "exit",
      "cancel",
      "discard"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FolderClosed",
    "filename": "folder-closed.svg",
    "category": "files",
    "tags": [
      "folder",
      "document",
      "catalog",
      "file",
      "closed",
      "archive"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "File",
    "filename": "file.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileVideo",
    "filename": "file-video.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "draft",
      "item",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileUpload",
    "filename": "file-upload.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "arrow",
      "up",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileTree",
    "filename": "file-tree.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "list",
      "bullet",
      "options"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileSub",
    "filename": "file-sub.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "list",
      "bullet",
      "options",
      "sub"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileSound",
    "filename": "file-sound.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "draft",
      "item",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileShare",
    "filename": "file-share.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "share"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileSettings",
    "filename": "file-settings.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileRefresh",
    "filename": "file-refresh.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FilePicture",
    "filename": "file-picture.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "draft",
      "item",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileMove",
    "filename": "file-move.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "transfer",
      "arrow",
      "right",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileMicrophone",
    "filename": "file-microphone.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "draft",
      "item",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileImport",
    "filename": "file-import.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "arrow",
      "right",
      "data",
      "import",
      "input"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileExport",
    "filename": "file-export.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "arrow",
      "right",
      "data",
      "share",
      "export",
      "output"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileEdit",
    "filename": "file-edit.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileDuplicate",
    "filename": "file-duplicate.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "duplicate",
      "copy",
      "clone",
      "paste"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileDownload",
    "filename": "file-download.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "arrow",
      "down",
      "data"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileDocument",
    "filename": "file-document.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "data",
      "pdf"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileDelete",
    "filename": "file-delete.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "clear",
      "delete",
      "remove",
      "close",
      "exit",
      "cancel",
      "discard"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileCode",
    "filename": "file-code.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "content",
      "data",
      "code"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileClear",
    "filename": "file-clear.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "clear",
      "delete",
      "remove",
      "close",
      "exit",
      "cancel",
      "discard"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileArchive",
    "filename": "file-archive.svg",
    "category": "files",
    "tags": [
      "file",
      "zip",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "data",
      "archive"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileAdd",
    "filename": "file-add.svg",
    "category": "files",
    "tags": [
      "file",
      "document",
      "note",
      "page",
      "draft",
      "item",
      "sheet",
      "content",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Speechless",
    "filename": "speechless.svg",
    "category": "emoticons",
    "tags": [
      "nps",
      "emoticon"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Smile",
    "filename": "smile.svg",
    "category": "emoticons",
    "tags": [
      "nps",
      "emoticon"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Satisfied",
    "filename": "satisfied.svg",
    "category": "emoticons",
    "tags": [
      "nps",
      "emoticon"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Sad",
    "filename": "sad.svg",
    "category": "emoticons",
    "tags": [
      "nps",
      "emoticon"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiTravelPlaces",
    "filename": "emoji-travel-places.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiSymbols",
    "filename": "emoji-symbols.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiSmileysPeople",
    "filename": "emoji-smileys-people.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiObjects",
    "filename": "emoji-objects.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiFrequentlyUsed",
    "filename": "emoji-frequently-used.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiFoodDrink",
    "filename": "emoji-food-drink.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiFlags",
    "filename": "emoji-flags.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiAnimalsNature",
    "filename": "emoji-animals-nature.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmojiActivity",
    "filename": "emoji-activity.svg",
    "category": "emoticons",
    "tags": [
      "emoji"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DeleteReaction",
    "filename": "delete-reaction.svg",
    "category": "emoticons",
    "tags": [
      "emoticon",
      "remove",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Angry",
    "filename": "angry.svg",
    "category": "emoticons",
    "tags": [
      "nps",
      "emoticon"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AddReaction",
    "filename": "add-reaction.svg",
    "category": "emoticons",
    "tags": [
      "emoticon",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "YesNo",
    "filename": "yes-no.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Welcome",
    "filename": "welcome.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Website",
    "filename": "website.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "world",
      "location",
      "globe",
      "earth"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UrlRedirect",
    "filename": "url-redirect.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "url",
      "end"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarScreenAspectVerticalSolid",
    "filename": "toolbar-screen-aspect-vertical-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "screen",
      "aspect",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarScreenAspectVerticalRegular",
    "filename": "toolbar-screen-aspect-vertical-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "screen",
      "aspect",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarScreenAspectSquareSolid",
    "filename": "toolbar-screen-aspect-square-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "screen",
      "aspect",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarScreenAspectSquareRegular",
    "filename": "toolbar-screen-aspect-square-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "screen",
      "aspect",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarScreenAspectHorizontalSolid",
    "filename": "toolbar-screen-aspect-horizontal-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "screen",
      "aspect",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarScreenAspectHorizontalRegular",
    "filename": "toolbar-screen-aspect-horizontal-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "screen",
      "aspect",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarPreviewSolid",
    "filename": "toolbar-preview-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "eye",
      "view",
      "visible",
      "watch",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarPreviewRegular",
    "filename": "toolbar-preview-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "eye",
      "view",
      "visible",
      "watch",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarCreateSolid",
    "filename": "toolbar-create-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarCreateRegular",
    "filename": "toolbar-create-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Statement",
    "filename": "statement.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "quote",
      "marks",
      "blockquote",
      "comment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ShortText",
    "filename": "short-text.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "text"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SettingsSolid",
    "filename": "settings-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SettingsRegular",
    "filename": "settings-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RoundedSmall",
    "filename": "rounded-small.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rounded",
      "radius"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RoundedNone",
    "filename": "rounded-none.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rounded",
      "radius"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RoundedMedium",
    "filename": "rounded-medium.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rounded",
      "radius"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RoundedFull",
    "filename": "rounded-full.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rounded",
      "radius"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Rating",
    "filename": "rating.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "star",
      "favorite"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingThumbUpSolid",
    "filename": "rating-thumb-up-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingThumbUpRegular",
    "filename": "rating-thumb-up-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingStarSolid",
    "filename": "rating-star-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "rating",
      "shapes",
      "star",
      "favorite"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingSmileSolid",
    "filename": "rating-smile-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingSmileRegular",
    "filename": "rating-smile-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingShapeRegular",
    "filename": "rating-shape-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rating",
      "shapes",
      "star",
      "favorite"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingHeartSolid",
    "filename": "rating-heart-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "rating",
      "shapes",
      "heart"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RatingHeartRegular",
    "filename": "rating-heart-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "rating",
      "shapes",
      "heart"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Ranking",
    "filename": "ranking.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "sort"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PictureChoice",
    "filename": "picture-choice.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "image"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Phone",
    "filename": "phone.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "phone",
      "message",
      "sms"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OpinionScale",
    "filename": "opinion-scale.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MultipleChoice",
    "filename": "multiple-choice.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "success",
      "select",
      "done",
      "checked",
      "tick",
      "completed",
      "choice"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Matrix",
    "filename": "matrix.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LongText",
    "filename": "long-text.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "text"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LogicSolid",
    "filename": "logic-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "logic",
      "branch"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LogicRegular",
    "filename": "logic-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "logic",
      "branch"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutWallpaper",
    "filename": "layout-wallpaper.svg",
    "category": "forms",
    "tags": [
      "forms",
      "layout",
      "place",
      "interface",
      "widget",
      "template"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutTopRight",
    "filename": "layout-top-right.svg",
    "category": "forms",
    "tags": [
      "forms",
      "transform",
      "resize",
      "measure"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutTopLeft",
    "filename": "layout-top-left.svg",
    "category": "forms",
    "tags": [
      "forms",
      "transform",
      "resize",
      "measure"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutStack",
    "filename": "layout-stack.svg",
    "category": "forms",
    "tags": [
      "forms",
      "layout",
      "place",
      "interface",
      "widget",
      "template"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutSplitRight",
    "filename": "layout-split-right.svg",
    "category": "forms",
    "tags": [
      "forms",
      "layout",
      "place",
      "interface",
      "widget",
      "template"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutSplitLeft",
    "filename": "layout-split-left.svg",
    "category": "forms",
    "tags": [
      "forms",
      "layout",
      "place",
      "interface",
      "widget",
      "template"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutFloatRight",
    "filename": "layout-float-right.svg",
    "category": "forms",
    "tags": [
      "forms",
      "layout",
      "place",
      "interface",
      "widget",
      "template"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutFloatLeft",
    "filename": "layout-float-left.svg",
    "category": "forms",
    "tags": [
      "forms",
      "layout",
      "place",
      "interface",
      "widget",
      "template"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutBottomRight",
    "filename": "layout-bottom-right.svg",
    "category": "forms",
    "tags": [
      "forms",
      "transform",
      "resize",
      "measure"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutBottomLeft",
    "filename": "layout-bottom-left.svg",
    "category": "forms",
    "tags": [
      "forms",
      "transform",
      "resize",
      "measure"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Group",
    "filename": "group.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Form",
    "filename": "form.svg",
    "category": "forms",
    "tags": [
      "forms",
      "file",
      "survey"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FormFile",
    "filename": "form-file.svg",
    "category": "forms",
    "tags": [
      "forms",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FormDelete",
    "filename": "form-delete.svg",
    "category": "forms",
    "tags": [
      "forms",
      "clear",
      "remove",
      "delete",
      "survey"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FormAdd",
    "filename": "form-add.svg",
    "category": "forms",
    "tags": [
      "forms",
      "plus",
      "create",
      "add",
      "survey"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Ended",
    "filename": "ended.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "end"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmbedTypeStandard",
    "filename": "embed-type-standard.svg",
    "category": "forms",
    "tags": [
      "forms",
      "embed"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmbedTypeSlider",
    "filename": "embed-type-slider.svg",
    "category": "forms",
    "tags": [
      "forms",
      "embed"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmbedTypeSideTab",
    "filename": "embed-type-side-tab.svg",
    "category": "forms",
    "tags": [
      "forms",
      "embed"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmbedTypePopup",
    "filename": "embed-type-popup.svg",
    "category": "forms",
    "tags": [
      "forms",
      "embed"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmbedTypePopover",
    "filename": "embed-type-popover.svg",
    "category": "forms",
    "tags": [
      "forms",
      "embed"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EmbedTypeFullPage",
    "filename": "embed-type-full-page.svg",
    "category": "forms",
    "tags": [
      "forms",
      "embed"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Dropdown",
    "filename": "dropdown.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DesignSolid",
    "filename": "design-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "palette",
      "design",
      "color",
      "paint"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DesignRegular",
    "filename": "design-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "palette",
      "design",
      "color",
      "paint"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Date",
    "filename": "date.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "calendar",
      "date",
      "time"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CreateSolid",
    "filename": "create-solid.svg",
    "category": "forms",
    "tags": [
      "forms",
      "solid",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CreateRegular",
    "filename": "create-regular.svg",
    "category": "forms",
    "tags": [
      "forms",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Contactinfo",
    "filename": "contactinfo.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "profile",
      "account",
      "avatar",
      "person",
      "member"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Collector",
    "filename": "collector.svg",
    "category": "forms",
    "tags": [
      "forms",
      "collector",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CollectorRemove",
    "filename": "collector-remove.svg",
    "category": "forms",
    "tags": [
      "forms",
      "collector",
      "clear",
      "remove",
      "delete",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CollectorAdd",
    "filename": "collector-add.svg",
    "category": "forms",
    "tags": [
      "forms",
      "collector",
      "plus",
      "create",
      "add",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CollectorActive",
    "filename": "collector-active.svg",
    "category": "forms",
    "tags": [
      "forms",
      "collector",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignmentRight",
    "filename": "alignment-right.svg",
    "category": "forms",
    "tags": [
      "forms",
      "alignment",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignmentLeft",
    "filename": "alignment-left.svg",
    "category": "forms",
    "tags": [
      "forms",
      "alignment",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignmentCenter",
    "filename": "alignment-center.svg",
    "category": "forms",
    "tags": [
      "forms",
      "alignment",
      "center"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Address",
    "filename": "address.svg",
    "category": "forms",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "location",
      "gps",
      "map"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeUser",
    "filename": "field-type-user.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeUrl",
    "filename": "field-type-url.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeTime",
    "filename": "field-type-time.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeText",
    "filename": "field-type-text.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeSystemUser",
    "filename": "field-type-system-user.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table",
      "dynamic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeSystemId",
    "filename": "field-type-system-id.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table",
      "dynamic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeSystemDate",
    "filename": "field-type-system-date.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table",
      "dynamic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeSingleSelect",
    "filename": "field-type-single-select.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeSelectAi",
    "filename": "field-type-select-ai.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeRating",
    "filename": "field-type-rating.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypePrimary",
    "filename": "field-type-primary.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypePhone",
    "filename": "field-type-phone.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypePercent",
    "filename": "field-type-percent.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeNumber",
    "filename": "field-type-number.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeMultiSelect",
    "filename": "field-type-multi-select.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeMail",
    "filename": "field-type-mail.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeLookup",
    "filename": "field-type-lookup.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeLongText",
    "filename": "field-type-long-text.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeLongTextAi",
    "filename": "field-type-long-text-ai.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeLock",
    "filename": "field-type-lock.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeLinked",
    "filename": "field-type-linked.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeLinkedAi",
    "filename": "field-type-linked-ai.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeFormula",
    "filename": "field-type-formula.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeFilter",
    "filename": "field-type-filter.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeDate",
    "filename": "field-type-date.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeDateAndTime",
    "filename": "field-type-date-and-time.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeCurrency",
    "filename": "field-type-currency.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeCount",
    "filename": "field-type-count.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeCheckbox",
    "filename": "field-type-checkbox.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeButton",
    "filename": "field-type-button.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeAutoNumber",
    "filename": "field-type-auto-number.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeAttachment",
    "filename": "field-type-attachment.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeArray",
    "filename": "field-type-array.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldTypeAi",
    "filename": "field-type-ai.svg",
    "category": "field-type",
    "tags": [
      "field",
      "type",
      "data",
      "datasheet",
      "table",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewSmall",
    "filename": "view-small.svg",
    "category": "design",
    "tags": [
      "view",
      "watch",
      "see",
      "show",
      "visibility",
      "visible",
      "preview",
      "read"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Version",
    "filename": "version.svg",
    "category": "design",
    "tags": [
      "history",
      "portfolio",
      "versions",
      "machine",
      "backup",
      "carousel"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TagSmall",
    "filename": "tag-small.svg",
    "category": "design",
    "tags": [
      "label",
      "badge",
      "mark",
      "ticket",
      "tag"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Swatchbook",
    "filename": "swatchbook.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "paint",
      "palette",
      "color"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SwatchbookAi",
    "filename": "swatchbook-ai.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "ai",
      "color",
      "palette",
      "paint"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Show",
    "filename": "show.svg",
    "category": "design",
    "tags": [
      "view",
      "watch",
      "see",
      "show",
      "visibility",
      "visible",
      "preview",
      "read"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Rename",
    "filename": "rename.svg",
    "category": "design",
    "tags": [
      "edit",
      "pencil",
      "create",
      "draw",
      "writer",
      "design"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Printer",
    "filename": "printer.svg",
    "category": "design",
    "tags": [
      "fax",
      "device",
      "office"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MaximizeAreaSmall",
    "filename": "maximize-area-small.svg",
    "category": "design",
    "tags": [
      "preview",
      "zoom",
      "expand",
      "fullscreen",
      "gallery"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Image",
    "filename": "image.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageSettings",
    "filename": "image-settings.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "system",
      "settings",
      "gear",
      "cog",
      "tools",
      "control",
      "preferences"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageRemove",
    "filename": "image-remove.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "remove",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageNew",
    "filename": "image-new.svg",
    "category": "design",
    "tags": [
      "image",
      "photo",
      "picture",
      "media",
      "gallery",
      "graphic",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageImport",
    "filename": "image-import.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "right",
      "input",
      "import"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageExport",
    "filename": "image-export.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "right",
      "arrow",
      "export"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageDuplicate",
    "filename": "image-duplicate.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "duplicate",
      "copy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageDelete",
    "filename": "image-delete.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "remove",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageAi",
    "filename": "image-ai.svg",
    "category": "design",
    "tags": [
      "image",
      "photo",
      "picture",
      "media",
      "gallery",
      "graphic",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageAdd",
    "filename": "image-add.svg",
    "category": "design",
    "tags": [
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Hide",
    "filename": "hide.svg",
    "category": "design",
    "tags": [
      "view",
      "watch",
      "see",
      "show",
      "visibility",
      "visible",
      "preview",
      "read"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FillColor",
    "filename": "fill-color.svg",
    "category": "design",
    "tags": [
      "image",
      "media",
      "picture",
      "gallery",
      "photo",
      "photography",
      "graphic",
      "color",
      "palette",
      "paint"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ExpandSmall",
    "filename": "expand-small.svg",
    "category": "design",
    "tags": [
      "preview",
      "zoom",
      "expand",
      "fullscreen",
      "gallery"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Edit",
    "filename": "edit.svg",
    "category": "design",
    "tags": [
      "edit",
      "pencil",
      "create",
      "draw",
      "writer",
      "design"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EditSmall",
    "filename": "edit-small.svg",
    "category": "design",
    "tags": [
      "edit",
      "pencil",
      "create",
      "draw",
      "writer",
      "design"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EditReadonly",
    "filename": "edit-readonly.svg",
    "category": "design",
    "tags": [
      "edit",
      "pencil",
      "create",
      "draw",
      "writer",
      "design"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Duplicate",
    "filename": "duplicate.svg",
    "category": "design",
    "tags": [
      "paste",
      "clone",
      "copy",
      "duplicate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DuplicateNew",
    "filename": "duplicate-new.svg",
    "category": "design",
    "tags": [
      "paste",
      "clone",
      "copy",
      "duplicate",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DeleteKeySmall",
    "filename": "delete-key-small.svg",
    "category": "design",
    "tags": [
      "backspace",
      "remove",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CopyTiny",
    "filename": "copy-tiny.svg",
    "category": "design",
    "tags": [
      "paste",
      "clone",
      "copy",
      "duplicate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CopySmall",
    "filename": "copy-small.svg",
    "category": "design",
    "tags": [
      "paste",
      "clone",
      "copy",
      "duplicate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CollapseLayers",
    "filename": "collapse-layers.svg",
    "category": "design",
    "tags": [
      "collapse",
      "expand",
      "details",
      "toggle",
      "accordion",
      "more",
      "less",
      "unfold"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UsersSmall",
    "filename": "users-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "organization",
      "group",
      "team"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UserSmall",
    "filename": "user-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UserSettingsSmall",
    "filename": "user-settings-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UserSearchSmall",
    "filename": "user-search-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "search",
      "magnifier",
      "glass",
      "view",
      "lookup"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UserRemoveSmall",
    "filename": "user-remove-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UserDeleteSmall",
    "filename": "user-delete-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UserCheckSmall",
    "filename": "user-check-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "success",
      "select",
      "done",
      "checked",
      "tick",
      "completed",
      "choice"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UserAddSmall",
    "filename": "user-add-small.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Use",
    "filename": "use.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseSettings",
    "filename": "use-settings.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseRemove",
    "filename": "use-remove.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseLock",
    "filename": "use-lock.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "lock",
      "security",
      "safe",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseInvitation",
    "filename": "use-invitation.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "arrow",
      "right",
      "import",
      "invitation"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseEdit",
    "filename": "use-edit.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "edit",
      "design",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseDelete",
    "filename": "use-delete.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseCancelInvitation",
    "filename": "use-cancel-invitation.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "arrow",
      "right",
      "import",
      "cancel",
      "invitation"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseAdminister",
    "filename": "use-administer.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseAdd",
    "filename": "use-add.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Security",
    "filename": "security.svg",
    "category": "collaborators",
    "tags": [
      "role",
      "lock",
      "security",
      "safe",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Role",
    "filename": "role.svg",
    "category": "collaborators",
    "tags": [
      "role",
      "lock",
      "security",
      "safe",
      "privacy",
      "key",
      "password"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RoleRemove",
    "filename": "role-remove.svg",
    "category": "collaborators",
    "tags": [
      "role",
      "lock",
      "security",
      "safe",
      "privacy",
      "key",
      "password"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RoleAdd",
    "filename": "role-add.svg",
    "category": "collaborators",
    "tags": [
      "role",
      "lock",
      "security",
      "safe",
      "privacy",
      "key",
      "password"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Organization",
    "filename": "organization.svg",
    "category": "collaborators",
    "tags": [
      "organization",
      "business",
      "company",
      "building"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OrganizationSwitch",
    "filename": "organization-switch.svg",
    "category": "collaborators",
    "tags": [
      "organization",
      "business",
      "company",
      "building",
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OrganizationJoin",
    "filename": "organization-join.svg",
    "category": "collaborators",
    "tags": [
      "organization",
      "business",
      "company",
      "building",
      "arrow",
      "right",
      "import",
      "input"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OrganizationAdd",
    "filename": "organization-add.svg",
    "category": "collaborators",
    "tags": [
      "organization",
      "business",
      "company",
      "building",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MemberAccounts",
    "filename": "member-accounts.svg",
    "category": "collaborators",
    "tags": [
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member",
      "docment",
      "book"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewSettings",
    "filename": "view-settings.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewKanban",
    "filename": "view-kanban.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "column"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewGrid",
    "filename": "view-grid.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewGallery",
    "filename": "view-gallery.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "gallery",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewForm",
    "filename": "view-form.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "form"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewDuplicate",
    "filename": "view-duplicate.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "duplicate",
      "copy",
      "clone",
      "paste"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewCalendar",
    "filename": "view-calendar.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "date",
      "calendar",
      "time"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewAdd",
    "filename": "view-add.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "view",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarSort",
    "filename": "toolbar-sort.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "arrow",
      "up",
      "down",
      "order",
      "filter",
      "sort"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarSettings",
    "filename": "toolbar-settings.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarRowHeightTall",
    "filename": "toolbar-row-height-tall.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "row",
      "view"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarRowHeightShort",
    "filename": "toolbar-row-height-short.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "row",
      "view"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarRowHeightMedium",
    "filename": "toolbar-row-height-medium.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "row",
      "view"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarRowHeightExtratall",
    "filename": "toolbar-row-height-extratall.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "row",
      "view"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarGroup",
    "filename": "toolbar-group.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "group"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarFilter",
    "filename": "toolbar-filter.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "toolbar",
      "filter"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RightSidebar",
    "filename": "right-sidebar.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "sidebar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordSettings",
    "filename": "record-settings.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordInsertTop",
    "filename": "record-insert-top.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "plus",
      "create",
      "add",
      "arrow",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordInsertBelow",
    "filename": "record-insert-below.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "plus",
      "create",
      "add",
      "arrow",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordHide",
    "filename": "record-hide.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "watch",
      "view",
      "eye",
      "visibility",
      "disabled",
      "hidden",
      "hide",
      "look"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordFreeze",
    "filename": "record-freeze.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "lock",
      "security",
      "safe",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordEdit",
    "filename": "record-edit.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordDuplicate",
    "filename": "record-duplicate.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "duplicate",
      "copy",
      "clone",
      "paste"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordDelete",
    "filename": "record-delete.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordCopyUrl",
    "filename": "record-copy-url.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "url",
      "duplicate",
      "copy",
      "clone",
      "paste"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordColor",
    "filename": "record-color.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "color",
      "bucket",
      "design",
      "fill",
      "paint"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RecordAdd",
    "filename": "record-add.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "record",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OptionsSortDescending",
    "filename": "options-sort-descending.svg",
    "category": "datasheets",
    "tags": [
      "order",
      "alpha",
      "sort",
      "alphabetical",
      "desc"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OptionsSortAscending",
    "filename": "options-sort-ascending.svg",
    "category": "datasheets",
    "tags": [
      "order",
      "alpha",
      "sort",
      "alphabetical",
      "asc"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LinkedDisassociate",
    "filename": "linked-disassociate.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "clear",
      "remove",
      "delete",
      "arrow",
      "right",
      "linked"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LinkedAdd",
    "filename": "linked-add.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "plus",
      "create",
      "add",
      "arrow",
      "right",
      "linked"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "History",
    "filename": "history.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "back",
      "loop",
      "process",
      "arrow",
      "clock",
      "time",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldSortedDesc",
    "filename": "field-sorted-desc.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "arrow",
      "down",
      "order",
      "filter",
      "sort",
      "desc"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldSortedAsc",
    "filename": "field-sorted-asc.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "arrow",
      "up",
      "order",
      "filter",
      "sort",
      "asc"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldSettings",
    "filename": "field-settings.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "control",
      "preferences",
      "system"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldRule",
    "filename": "field-rule.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "rule",
      "user",
      "account",
      "profile",
      "avatar",
      "person",
      "human",
      "member"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldPrimary",
    "filename": "field-primary.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "flag",
      "map",
      "tag"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldInsertRight",
    "filename": "field-insert-right.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "plus",
      "create",
      "add",
      "arrow",
      "up"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldInsertLeft",
    "filename": "field-insert-left.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "plus",
      "create",
      "add",
      "arrow",
      "up"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldHide",
    "filename": "field-hide.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "watch",
      "view",
      "eye",
      "visibility",
      "disabled",
      "hidden",
      "hide",
      "look"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldFreeze",
    "filename": "field-freeze.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "lock",
      "security",
      "safe",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldEdit",
    "filename": "field-edit.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldDynamic",
    "filename": "field-dynamic.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "dynamic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldDuplicate",
    "filename": "field-duplicate.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "duplicate",
      "copy",
      "clone",
      "paste"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldDelete",
    "filename": "field-delete.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FieldAdd",
    "filename": "field-add.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "field",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Extensions",
    "filename": "extensions.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "plug",
      "energy",
      "power"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DynamicValue",
    "filename": "dynamic-value.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "typography",
      "dynamic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DynamicLinked",
    "filename": "dynamic-linked.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "arrow",
      "right",
      "linked",
      "dynamic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DynamicDate",
    "filename": "dynamic-date.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "date",
      "calendar",
      "dynamic",
      "time"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApiDocument",
    "filename": "api-document.svg",
    "category": "datasheets",
    "tags": [
      "data",
      "datasheet",
      "table",
      "document",
      "api",
      "book"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SwitchRightSidebar",
    "filename": "switch-right-sidebar.svg",
    "category": "automation",
    "tags": [
      "sidebar",
      "right",
      "automation"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SwitchBottomPanel",
    "filename": "switch-bottom-panel.svg",
    "category": "automation",
    "tags": [
      "sidebar",
      "bottom",
      "automation"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Pin",
    "filename": "pin.svg",
    "category": "automation",
    "tags": [
      "automation",
      "lock",
      "fix",
      "map",
      "save"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PinOff",
    "filename": "pin-off.svg",
    "category": "automation",
    "tags": [
      "automation",
      "lock",
      "fix",
      "map",
      "save"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OpenWindow",
    "filename": "open-window.svg",
    "category": "automation",
    "tags": [
      "automation",
      "windows",
      "open"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "JsonDataTable",
    "filename": "json-data-table.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "JsonDataSchema",
    "filename": "json-data-schema.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "JsonDataJson",
    "filename": "json-data-json.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "FlowSidebar",
    "filename": "flow-sidebar.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "CloseWindow",
    "filename": "close-window.svg",
    "category": "automation",
    "tags": [
      "automation",
      "windows",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationZoomOut",
    "filename": "application-zoom-out.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationZoomIn",
    "filename": "application-zoom-in.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationUndo",
    "filename": "application-undo.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationTidy",
    "filename": "application-tidy.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationRedo",
    "filename": "application-redo.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationHistory",
    "filename": "application-history.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationCopilot",
    "filename": "application-copilot.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplicationAdd",
    "filename": "application-add.svg",
    "category": "automation",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "AiOverrideField",
    "filename": "ai-override-field.svg",
    "category": "automation",
    "tags": [
      "ai",
      "integration",
      "extension",
      "sparkle",
      "magic",
      "automation"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ZoomOut",
    "filename": "zoom-out.svg",
    "category": "common",
    "tags": [
      "common",
      "magnifier",
      "glass",
      "view",
      "lookup"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ZoomOutSmall",
    "filename": "zoom-out-small.svg",
    "category": "common",
    "tags": [
      "common",
      "magnifier",
      "glass",
      "view",
      "lookup"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ZoomIn",
    "filename": "zoom-in.svg",
    "category": "common",
    "tags": [
      "common",
      "magnifier",
      "glass",
      "view",
      "lookup"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ZoomInSmall",
    "filename": "zoom-in-small.svg",
    "category": "common",
    "tags": [
      "common",
      "magnifier",
      "glass",
      "view",
      "lookup"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UnlockSolid",
    "filename": "unlock-solid.svg",
    "category": "common",
    "tags": [
      "interface",
      "solid",
      "lock",
      "locked",
      "secure",
      "password",
      "key",
      "safety",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UnlockSmall",
    "filename": "unlock-small.svg",
    "category": "common",
    "tags": [
      "common",
      "lock",
      "locked",
      "secure",
      "password",
      "key",
      "safety",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Trash",
    "filename": "trash.svg",
    "category": "common",
    "tags": [
      "common",
      "remove",
      "delete",
      "close",
      "garbage",
      "bin"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TrashSmall",
    "filename": "trash-small.svg",
    "category": "common",
    "tags": [
      "common",
      "remove",
      "delete",
      "close",
      "garbage",
      "bin"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ThumbUp",
    "filename": "thumb-up.svg",
    "category": "common",
    "tags": [
      "common",
      "bookmark",
      "favorite",
      "like",
      "review",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ThumbDown",
    "filename": "thumb-down.svg",
    "category": "common",
    "tags": [
      "common",
      "bookmark",
      "favorite",
      "like",
      "review",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ThemeSystem",
    "filename": "theme-system.svg",
    "category": "common",
    "tags": [
      "common",
      "theme",
      "system",
      "display",
      "computer",
      "desktop",
      "pc",
      "workstation"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ThemeSunBright",
    "filename": "theme-sun-bright.svg",
    "category": "common",
    "tags": [
      "common",
      "theme",
      "weather",
      "sun"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ThemeMoonDark",
    "filename": "theme-moon-dark.svg",
    "category": "common",
    "tags": [
      "common",
      "theme",
      "weather",
      "moon"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TagRemove",
    "filename": "tag-remove.svg",
    "category": "common",
    "tags": [
      "common",
      "tag",
      "label",
      "badge",
      "ticket",
      "remove",
      "minus",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TagAdd",
    "filename": "tag-add.svg",
    "category": "common",
    "tags": [
      "common",
      "tag",
      "label",
      "badge",
      "ticket",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TabletToolbar",
    "filename": "tablet-toolbar.svg",
    "category": "common",
    "tags": [
      "toolbar",
      "display",
      "responsive",
      "device",
      "phone",
      "tablet",
      "screen"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SystemPreferences",
    "filename": "system-preferences.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SystemConfiguration",
    "filename": "system-configuration.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Support",
    "filename": "support.svg",
    "category": "common",
    "tags": [
      "common",
      "help",
      "lifesaver",
      "preserver"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SupportSmall",
    "filename": "support-small.svg",
    "category": "common",
    "tags": [
      "common",
      "help",
      "lifesaver",
      "preserver"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Star",
    "filename": "star.svg",
    "category": "common",
    "tags": [
      "common",
      "bookmark",
      "favorite",
      "like",
      "review",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StarSolid",
    "filename": "star-solid.svg",
    "category": "common",
    "tags": [
      "common",
      "bookmark",
      "favorite",
      "like",
      "review",
      "rating",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareRemoveSquarevg",
    "filename": "square-remove.squarevg.svg",
    "category": "common",
    "tags": [
      "common",
      "square",
      "remove",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareDeleteSquarevg",
    "filename": "square-delete.squarevg.svg",
    "category": "common",
    "tags": [
      "common",
      "square",
      "remove",
      "minus",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareAddSquarevg",
    "filename": "square-add.squarevg.svg",
    "category": "common",
    "tags": [
      "common",
      "square",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SocialSharing",
    "filename": "social-sharing.svg",
    "category": "common",
    "tags": [
      "common",
      "network",
      "share",
      "connections",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Sharing",
    "filename": "sharing.svg",
    "category": "common",
    "tags": [
      "common",
      "network",
      "share",
      "connections",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Share",
    "filename": "share.svg",
    "category": "common",
    "tags": [
      "common",
      "network",
      "share",
      "connections",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SetupPreferences",
    "filename": "setup-preferences.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Settings",
    "filename": "settings.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "gear",
      "cog",
      "tools",
      "control",
      "preferences"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Send",
    "filename": "send.svg",
    "category": "common",
    "tags": [
      "email",
      "send",
      "message",
      "letter",
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SendMessageSmall",
    "filename": "send-message-small.svg",
    "category": "common",
    "tags": [
      "email",
      "send",
      "message",
      "letter",
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Search",
    "filename": "search.svg",
    "category": "common",
    "tags": [
      "common",
      "magnifier",
      "glass",
      "view",
      "lookup"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SearchSmall",
    "filename": "search-small.svg",
    "category": "common",
    "tags": [
      "common",
      "magnifier",
      "glass",
      "view",
      "lookup"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RoboSmall",
    "filename": "robo-small.svg",
    "category": "common",
    "tags": [
      "common",
      "sparks",
      "ai",
      "effect",
      "brightness",
      "interlligence"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Remove",
    "filename": "remove.svg",
    "category": "common",
    "tags": [
      "common",
      "clear",
      "delete",
      "remove",
      "close",
      "exit",
      "cancel",
      "discard"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RemoveTiny",
    "filename": "remove-tiny.svg",
    "category": "common",
    "tags": [
      "common",
      "clear",
      "delete",
      "remove",
      "close",
      "exit",
      "cancel",
      "discard"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RemoveSmall",
    "filename": "remove-small.svg",
    "category": "common",
    "tags": [
      "common",
      "clear",
      "delete",
      "remove",
      "close",
      "exit",
      "cancel",
      "discard"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RadioBtn",
    "filename": "radio-btn.svg",
    "category": "common",
    "tags": [
      "common",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RadioBtnChecked",
    "filename": "radio-btn-checked.svg",
    "category": "common",
    "tags": [
      "common",
      "circle",
      "complete",
      "done",
      "check"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "QrCode",
    "filename": "qr-code.svg",
    "category": "common",
    "tags": [
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Preferences",
    "filename": "preferences.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PhoneToolbar",
    "filename": "phone-toolbar.svg",
    "category": "common",
    "tags": [
      "toolbar",
      "display",
      "responsive",
      "device",
      "phone",
      "tablet",
      "screen"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PcToolbar",
    "filename": "pc-toolbar.svg",
    "category": "common",
    "tags": [
      "toolbar",
      "display",
      "responsive",
      "device",
      "computer",
      "pc",
      "desktop",
      "screen"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Options",
    "filename": "options.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "NetworkConnection",
    "filename": "network-connection.svg",
    "category": "common",
    "tags": [
      "common",
      "network",
      "share",
      "connections"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Menu",
    "filename": "menu.svg",
    "category": "common",
    "tags": [
      "common",
      "bars",
      "navigation",
      "hamburger",
      "options"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MailSmall",
    "filename": "mail-small.svg",
    "category": "common",
    "tags": [
      "email",
      "send",
      "message",
      "letter",
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LogLists",
    "filename": "log-lists.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools",
      "list"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Lock",
    "filename": "lock.svg",
    "category": "common",
    "tags": [
      "common",
      "lock",
      "locked",
      "secure",
      "password",
      "key",
      "safety",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LockSolid",
    "filename": "lock-solid.svg",
    "category": "common",
    "tags": [
      "interface",
      "solid",
      "lock",
      "locked",
      "secure",
      "password",
      "key",
      "safety",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LockSmall",
    "filename": "lock-small.svg",
    "category": "common",
    "tags": [
      "common",
      "lock",
      "locked",
      "secure",
      "password",
      "key",
      "safety",
      "privacy"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LoaderCircle",
    "filename": "loader-circle.svg",
    "category": "common",
    "tags": [
      "common",
      "loading",
      "progress",
      "spinner",
      "wait"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Launch",
    "filename": "launch.svg",
    "category": "common",
    "tags": [
      "common",
      "network",
      "share",
      "connections",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LaunchApp",
    "filename": "launch-app.svg",
    "category": "common",
    "tags": [
      "common",
      "network",
      "share",
      "connections",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Indeterminate",
    "filename": "indeterminate.svg",
    "category": "common",
    "tags": [
      "common",
      "indeterminate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GripVerticalSmall",
    "filename": "grip-vertical-small.svg",
    "category": "common",
    "tags": [
      "common",
      "dots",
      "menu",
      "circle",
      "more",
      "vertical"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GripHorizontalSmall",
    "filename": "grip-horizontal-small.svg",
    "category": "common",
    "tags": [
      "common",
      "dots",
      "menu",
      "circle",
      "more",
      "horizontal"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GridInterface",
    "filename": "grid-interface.svg",
    "category": "common",
    "tags": [
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GalleryView",
    "filename": "gallery-view.svg",
    "category": "common",
    "tags": [
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Favorite",
    "filename": "favorite.svg",
    "category": "common",
    "tags": [
      "common",
      "bookmark",
      "favorite",
      "like",
      "review",
      "rating"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FavoriteSolid",
    "filename": "favorite-solid.svg",
    "category": "common",
    "tags": [
      "common",
      "bookmark",
      "favorite",
      "like",
      "review",
      "rating",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Email",
    "filename": "email.svg",
    "category": "common",
    "tags": [
      "forms",
      "question",
      "type",
      "form",
      "email",
      "send",
      "message",
      "letter",
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EllipsisVerticalSmall",
    "filename": "ellipsis-vertical-small.svg",
    "category": "common",
    "tags": [
      "common",
      "dots",
      "menu",
      "circle",
      "more",
      "ellipsis",
      "vertical"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EllipsisSmall",
    "filename": "ellipsis-small.svg",
    "category": "common",
    "tags": [
      "common",
      "dots",
      "menu",
      "circle",
      "more",
      "ellipsis",
      "horizontal"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Dot",
    "filename": "dot.svg",
    "category": "common",
    "tags": [
      "common",
      "radio"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Delete",
    "filename": "delete.svg",
    "category": "common",
    "tags": [
      "common",
      "minus",
      "clear",
      "remove",
      "close",
      "cancel",
      "deletion",
      "less"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DeleteTiny",
    "filename": "delete-tiny.svg",
    "category": "common",
    "tags": [
      "common",
      "minus",
      "clear",
      "remove",
      "close",
      "cancel",
      "deletion",
      "less"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DeleteSmall",
    "filename": "delete-small.svg",
    "category": "common",
    "tags": [
      "common",
      "minus",
      "clear",
      "remove",
      "close",
      "cancel",
      "deletion",
      "less"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CogwheelSolidSmall",
    "filename": "cogwheel-solid-small.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools",
      "cog",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CogwheelSmall",
    "filename": "cogwheel-small.svg",
    "category": "common",
    "tags": [
      "common",
      "system",
      "settings",
      "control",
      "preferences",
      "tools",
      "cog"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Clock",
    "filename": "clock.svg",
    "category": "common",
    "tags": [
      "common",
      "clock",
      "day",
      "time",
      "watch"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ClipboardSmall",
    "filename": "clipboard-small.svg",
    "category": "common",
    "tags": [
      "paste",
      "clone",
      "copy",
      "duplicate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleRemove",
    "filename": "circle-remove.svg",
    "category": "common",
    "tags": [
      "common",
      "circle",
      "remove",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleCirclehecirclek",
    "filename": "circle-circlehecirclek.svg",
    "category": "common",
    "tags": [
      "common",
      "circle",
      "complete",
      "done",
      "checkbox",
      "check"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleAdd",
    "filename": "circle-add.svg",
    "category": "common",
    "tags": [
      "common",
      "circle",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CheckboxBtn",
    "filename": "checkbox-btn.svg",
    "category": "common",
    "tags": [
      "common",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CheckboxBtnChecked",
    "filename": "checkbox-btn-checked.svg",
    "category": "common",
    "tags": [
      "common",
      "square",
      "checkbox",
      "check",
      "done",
      "complete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Check",
    "filename": "check.svg",
    "category": "common",
    "tags": [
      "common",
      "success",
      "select",
      "done",
      "checked",
      "tick",
      "completed",
      "choice"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BinSmall",
    "filename": "bin-small.svg",
    "category": "common",
    "tags": [
      "common",
      "remove",
      "delete",
      "close",
      "garbage",
      "bin"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Ban",
    "filename": "ban.svg",
    "category": "common",
    "tags": [
      "common",
      "circle",
      "cancel",
      "ban",
      "error",
      "slash",
      "wrong",
      "failure",
      "null"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AttachSmall",
    "filename": "attach-small.svg",
    "category": "common",
    "tags": [
      "attach",
      "file",
      "attachment",
      "inbox",
      "email",
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AtSign",
    "filename": "at-sign.svg",
    "category": "common",
    "tags": [
      "mention",
      "email",
      "send",
      "sign",
      "at",
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AtSignSmall",
    "filename": "at-sign-small.svg",
    "category": "common",
    "tags": [
      "mention",
      "email",
      "send",
      "sign",
      "at",
      "common"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Ai",
    "filename": "ai.svg",
    "category": "common",
    "tags": [
      "common",
      "sparks",
      "ai",
      "effect",
      "brightness",
      "interlligence"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Add",
    "filename": "add.svg",
    "category": "common",
    "tags": [
      "common",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AddTiny",
    "filename": "add-tiny.svg",
    "category": "common",
    "tags": [
      "common",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AddSmall",
    "filename": "add-small.svg",
    "category": "common",
    "tags": [
      "common",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ViewChart",
    "filename": "view-chart.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TrendLine",
    "filename": "trend-line.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Table",
    "filename": "table.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StackedBar",
    "filename": "stacked-bar.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "stacked"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ScrollingWords",
    "filename": "scrolling-words.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RowStacked",
    "filename": "row-stacked.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "stacked"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RowNormal",
    "filename": "row-normal.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RowGroup",
    "filename": "row-group.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Radar",
    "filename": "radar.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Quadrant",
    "filename": "quadrant.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Pie",
    "filename": "pie.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Picture",
    "filename": "picture.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "image"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Number",
    "filename": "number.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Nps",
    "filename": "nps.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MultipleAxes",
    "filename": "multiple-axes.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MultiLine",
    "filename": "multi-line.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MixedLineAndBar",
    "filename": "mixed-line-and-bar.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Line",
    "filename": "line.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Journey",
    "filename": "journey.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Filter",
    "filename": "filter.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "filter"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FilterBlock",
    "filename": "filter-block.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "filter"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Doughnut",
    "filename": "doughnut.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DoubleLine",
    "filename": "double-line.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Divider",
    "filename": "divider.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "divider"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Column",
    "filename": "column.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "column"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColumnStacked",
    "filename": "column-stacked.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "column",
      "stacked"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColumnNormal",
    "filename": "column-normal.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "column"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColumnGroup",
    "filename": "column-group.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "column"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChartEdit",
    "filename": "chart-edit.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "pen",
      "pencil",
      "draw",
      "create"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChartDelete",
    "filename": "chart-delete.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Blueprint",
    "filename": "blueprint.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BlueprintTimeline",
    "filename": "blueprint-timeline.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "timeline",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BlueprintNode",
    "filename": "blueprint-node.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BlueprintDivider",
    "filename": "blueprint-divider.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "divider",
      "line"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BlockDelete",
    "filename": "block-delete.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "clear",
      "remove",
      "delete"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BlockAdd",
    "filename": "block-add.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "plus",
      "create",
      "add"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Biaxial",
    "filename": "biaxial.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Bar",
    "filename": "bar.svg",
    "category": "charts",
    "tags": [
      "chart",
      "data",
      "statistics",
      "report",
      "analysis",
      "visualization",
      "performance",
      "graph",
      "business",
      "bar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DistributeVertical",
    "filename": "distribute-vertical.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "distribute",
      "vertical",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DistributeVerticalSolid",
    "filename": "distribute-vertical-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "distribute",
      "vertical",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DistributeHorizontal",
    "filename": "distribute-horizontal.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "distribute",
      "horizontal",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DistributeHorizontalSolid",
    "filename": "distribute-horizontal-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "distribute",
      "horizontal",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignTop",
    "filename": "align-top.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "top",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignTopSolid",
    "filename": "align-top-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "top",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignRight",
    "filename": "align-right.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "right",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignRightSolid",
    "filename": "align-right-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "right",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignLeft",
    "filename": "align-left.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "left",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignLeftSolid",
    "filename": "align-left-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "left",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignCenterVertical",
    "filename": "align-center-vertical.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "center",
      "vertical",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignCenterVerticalSolid",
    "filename": "align-center-vertical-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "center",
      "vertical",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignCenterHorizontal",
    "filename": "align-center-horizontal.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "center",
      "horizontal",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignCenterHorizontalSolid",
    "filename": "align-center-horizontal-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "center",
      "horizontal",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignBottom",
    "filename": "align-bottom.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "bottom",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlignBottomSolid",
    "filename": "align-bottom-solid.svg",
    "category": "alignment",
    "tags": [
      "alignment",
      "align",
      "bottom",
      "solid",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "XCircle",
    "filename": "x-circle.svg",
    "category": "alert",
    "tags": [
      "alert",
      "remove",
      "delete",
      "close",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "XCircle1",
    "filename": "x-circle-1.svg",
    "category": "alert",
    "tags": [
      "alert",
      "remove",
      "delete",
      "close",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningTriangle",
    "filename": "warning-triangle.svg",
    "category": "alert",
    "tags": [
      "alert",
      "warning",
      "triangle",
      "info"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningTriangleSmall",
    "filename": "warning-triangle-small.svg",
    "category": "alert",
    "tags": [
      "alert",
      "warning",
      "triangle",
      "info"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningSquare",
    "filename": "warning-square.svg",
    "category": "alert",
    "tags": [
      "alert",
      "info",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningRhomboidSmall",
    "filename": "warning-rhomboid-small.svg",
    "category": "alert",
    "tags": [
      "alert",
      "warning",
      "info"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningHexagonSmall",
    "filename": "warning-hexagon-small.svg",
    "category": "alert",
    "tags": [
      "alert",
      "warning",
      "info"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "WarningCircle",
    "filename": "warning-circle.svg",
    "category": "alert",
    "tags": [
      "alert",
      "info",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriangleWarningLarge",
    "filename": "triangle-warning-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "warning"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriangleWarningLargeSolid",
    "filename": "triangle-warning-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "warning"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareWarningLarge",
    "filename": "square-warning-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "warning",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareWarningLargeSolid",
    "filename": "square-warning-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "warning",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareQuestionLarge",
    "filename": "square-question-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "question",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareQuestionLargeSolid",
    "filename": "square-question-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "question",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareInfoLarge",
    "filename": "square-info-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "info",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SquareInfoLargeSolid",
    "filename": "square-info-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "info",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "QuestionSquare",
    "filename": "question-square.svg",
    "category": "alert",
    "tags": [
      "alert",
      "question",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "QuestionCircle",
    "filename": "question-circle.svg",
    "category": "alert",
    "tags": [
      "alert",
      "question",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Notifications",
    "filename": "notifications.svg",
    "category": "alert",
    "tags": [
      "alert",
      "alarm",
      "notification",
      "bell"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Megaphone",
    "filename": "megaphone.svg",
    "category": "alert",
    "tags": [
      "alert",
      "alarm",
      "notification",
      "bell"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InfoSquare",
    "filename": "info-square.svg",
    "category": "alert",
    "tags": [
      "alert",
      "info",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InfoCircle",
    "filename": "info-circle.svg",
    "category": "alert",
    "tags": [
      "alert",
      "info",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Comment",
    "filename": "comment.svg",
    "category": "alert",
    "tags": [
      "alert",
      "alarm",
      "answer",
      "reply",
      "message",
      "chat"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleWarningLarge",
    "filename": "circle-warning-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "warning",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleWarningLargeSolid",
    "filename": "circle-warning-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "warning",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleRemoveLarge",
    "filename": "circle-remove-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "remove",
      "delete",
      "close",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleRemoveLargeSolid",
    "filename": "circle-remove-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "remove",
      "delete",
      "close",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleQuestionLarge",
    "filename": "circle-question-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "question",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleQuestionLargeSolid",
    "filename": "circle-question-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "question",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleInfoLarge",
    "filename": "circle-info-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "info",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleInfoLargeSolid",
    "filename": "circle-info-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "info",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleCheckLarge",
    "filename": "circle-check-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "check",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CircleCheckLargeSolid",
    "filename": "circle-check-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "check",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CheckSquare",
    "filename": "check-square.svg",
    "category": "alert",
    "tags": [
      "alert",
      "check",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CheckCircle",
    "filename": "check-circle.svg",
    "category": "alert",
    "tags": [
      "alert",
      "check",
      "circle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Chat",
    "filename": "chat.svg",
    "category": "alert",
    "tags": [
      "alert",
      "alarm",
      "answer",
      "reply",
      "message",
      "chat"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChatLarge",
    "filename": "chat-large.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "chat",
      "message",
      "reply",
      "answer"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChatLargeSolid",
    "filename": "chat-large-solid.svg",
    "category": "alert",
    "tags": [
      "solid",
      "alert",
      "answer"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlarmSmall",
    "filename": "alarm-small.svg",
    "category": "alert",
    "tags": [
      "alert",
      "alarm",
      "notification",
      "bell"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AlarmSmallSolid",
    "filename": "alarm-small-solid.svg",
    "category": "alert",
    "tags": [
      "alert",
      "alarm",
      "notification",
      "bell",
      "solid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Upload",
    "filename": "upload.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "top",
      "up",
      "upload",
      "push",
      "data",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UploadData",
    "filename": "upload-data.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "top",
      "up",
      "upload",
      "push",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UpArrowSmall",
    "filename": "up-arrow-small.svg",
    "category": "arrows",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "Undo",
    "filename": "undo.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left",
      "back",
      "backward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriangleUp",
    "filename": "triangle-up.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "up"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriangleRight",
    "filename": "triangle-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriangleLeft",
    "filename": "triangle-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TriangleDown",
    "filename": "triangle-down.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "down"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TransactionSmall",
    "filename": "transaction-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "horizontal",
      "flip",
      "directions",
      "swap"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TrafficSmall",
    "filename": "traffic-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "swap",
      "vertical",
      "flip"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SystemUpdate",
    "filename": "system-update.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "data",
      "file",
      "import",
      "download"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SwapVerticalSmall",
    "filename": "swap-vertical-small.svg",
    "category": "arrows",
    "tags": [
      "flip",
      "arrow",
      "swap",
      "vertical"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SwapHorizontalSmall",
    "filename": "swap-horizontal-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "horizontal",
      "flip",
      "directions",
      "swap"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SlideRight",
    "filename": "slide-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SlideLeft",
    "filename": "slide-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left",
      "back",
      "backward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RightArrowSmall",
    "filename": "right-arrow-small.svg",
    "category": "arrows",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "RespondArrow",
    "filename": "respond-arrow.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ResizeYSmall",
    "filename": "resize-y-small.svg",
    "category": "arrows",
    "tags": [
      "resize",
      "vertical",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ResizeXSmall",
    "filename": "resize-x-small.svg",
    "category": "arrows",
    "tags": [
      "resize",
      "horizontal",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ReplyArrow",
    "filename": "reply-arrow.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left",
      "back",
      "backward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Reload",
    "filename": "reload.svg",
    "category": "arrows",
    "tags": [
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Refresh",
    "filename": "refresh.svg",
    "category": "arrows",
    "tags": [
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Redo",
    "filename": "redo.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "redo",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Logout",
    "filename": "logout.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LogOutSmall",
    "filename": "log-out-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LogIn",
    "filename": "log-in.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LeftArrowSmall",
    "filename": "left-arrow-small.svg",
    "category": "arrows",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "Input",
    "filename": "input.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "data",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Forward",
    "filename": "forward.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "top",
      "up",
      "upload",
      "push"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FormatRight",
    "filename": "format-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FormatLeft",
    "filename": "format-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left",
      "back",
      "backward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FilesUpload",
    "filename": "files-upload.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "data",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FilesDownload",
    "filename": "files-download.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "data",
      "file",
      "import",
      "download"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Enlarge",
    "filename": "enlarge.svg",
    "category": "arrows",
    "tags": [
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EnlargeH",
    "filename": "enlarge-h.svg",
    "category": "arrows",
    "tags": [
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Download",
    "filename": "download.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "data",
      "file",
      "import",
      "download"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DownloadData",
    "filename": "download-data.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "import",
      "download",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DownArrowSmall",
    "filename": "down-arrow-small.svg",
    "category": "arrows",
    "tags": [],
    "width": 16,
    "height": 16
  },
  {
    "name": "DoubleArrowRight",
    "filename": "double-arrow-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DoubleArrowMediumRight",
    "filename": "double-arrow-medium-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "forward",
      "more"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DoubleArrowMediumLeft",
    "filename": "double-arrow-medium-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left",
      "back",
      "backward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DoubleArrowLeft",
    "filename": "double-arrow-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left",
      "back",
      "backward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DataUpload",
    "filename": "data-upload.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "top",
      "up",
      "upload",
      "push",
      "data",
      "file"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DataDownload",
    "filename": "data-download.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "file",
      "data",
      "import",
      "download"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Cycle",
    "filename": "cycle.svg",
    "category": "arrows",
    "tags": [
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CurvedArrowRight",
    "filename": "curved-arrow-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left",
      "forward",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CurvedArrowLeft",
    "filename": "curved-arrow-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right",
      "back",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ConversionSmall",
    "filename": "conversion-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "horizontal",
      "flip",
      "directions",
      "swap",
      "conversion"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronUp",
    "filename": "chevron-up.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "up"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronUpSmall",
    "filename": "chevron-up-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "up"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronRight",
    "filename": "chevron-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronRightSmall",
    "filename": "chevron-right-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronRightMedium",
    "filename": "chevron-right-medium.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronLeft",
    "filename": "chevron-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronLeftSmall",
    "filename": "chevron-left-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronLeftMedium",
    "filename": "chevron-left-medium.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronDown",
    "filename": "chevron-down.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "down"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ChevronDownSmall",
    "filename": "chevron-down-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "down"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Backward",
    "filename": "backward.svg",
    "category": "arrows",
    "tags": [
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowsMaximize",
    "filename": "arrows-maximize.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "fullscreen",
      "expand"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowsMaximizeSmall",
    "filename": "arrows-maximize-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "fullscreen",
      "expand"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowUp",
    "filename": "arrow-up.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "up"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowRight",
    "filename": "arrow-right.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowMinimize",
    "filename": "arrow-minimize.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "exit",
      "close",
      "shrink"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowMinimizeSmall",
    "filename": "arrow-minimize-small.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "exit",
      "close",
      "shrink"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowLeft",
    "filename": "arrow-left.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArrowDown",
    "filename": "arrow-down.svg",
    "category": "arrows",
    "tags": [
      "arrow",
      "down"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Visible",
    "filename": "visible.svg",
    "category": "interface",
    "tags": [
      "interface",
      "view",
      "watch",
      "see",
      "show",
      "visibility",
      "visible",
      "preview",
      "read"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Viewport",
    "filename": "viewport.svg",
    "category": "interface",
    "tags": [
      "interface",
      "layout",
      "browser",
      "web"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VedioSmall",
    "filename": "vedio-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "media"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorShapeBuilder",
    "filename": "vector-shape-builder.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorNode",
    "filename": "vector-node.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorMove",
    "filename": "vector-move.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorLasso",
    "filename": "vector-lasso.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorJoinAnchors",
    "filename": "vector-join-anchors.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorFlatten",
    "filename": "vector-flatten.svg",
    "category": "interface",
    "tags": [
      "vector",
      "interface",
      "path"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorCut",
    "filename": "vector-cut.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VectorBend",
    "filename": "vector-bend.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariablesString",
    "filename": "variables-string.svg",
    "category": "interface",
    "tags": [
      "interface",
      "variables",
      "typography",
      "text",
      "input",
      "font",
      "paragraph",
      "format"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariablesObject",
    "filename": "variables-object.svg",
    "category": "interface",
    "tags": [
      "field",
      "type",
      "data",
      "table",
      "variables"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariablesNumber",
    "filename": "variables-number.svg",
    "category": "interface",
    "tags": [
      "interface",
      "variables",
      "hash",
      "number",
      "href"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariablesEnum",
    "filename": "variables-enum.svg",
    "category": "interface",
    "tags": [
      "interface",
      "variables",
      "dropdown",
      "arrow",
      "down"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariablesColor",
    "filename": "variables-color.svg",
    "category": "interface",
    "tags": [
      "interface",
      "variables",
      "palette",
      "design",
      "paint",
      "color",
      "art",
      "draw"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariablesBoolean",
    "filename": "variables-boolean.svg",
    "category": "interface",
    "tags": [
      "interface",
      "variables",
      "toggle",
      "switch",
      "preferences",
      "options"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariablesArray",
    "filename": "variables-array.svg",
    "category": "interface",
    "tags": [
      "field",
      "type",
      "data",
      "table",
      "variables"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Variable",
    "filename": "variable.svg",
    "category": "interface",
    "tags": [
      "interface",
      "variables"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariableWidth",
    "filename": "variable-width.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "VariableSettings",
    "filename": "variable-settings.svg",
    "category": "interface",
    "tags": [
      "variable",
      "interface",
      "typography",
      "text",
      "input",
      "font",
      "paragraph",
      "format",
      "style"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UseMask",
    "filename": "use-mask.svg",
    "category": "interface",
    "tags": [
      "interface",
      "mask"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "UnlockAspectRatio",
    "filename": "unlock-aspect-ratio.svg",
    "category": "interface",
    "tags": [
      "interface",
      "link",
      "connection",
      "url",
      "hyperlink",
      "aspect"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TransformsScale",
    "filename": "transforms-scale.svg",
    "category": "interface",
    "tags": [
      "interface",
      "sharing",
      "expand"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TransformsRotate",
    "filename": "transforms-rotate.svg",
    "category": "interface",
    "tags": [
      "interface",
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh",
      "rotate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TransformsPerspective",
    "filename": "transforms-perspective.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "3d",
      "axis"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TransformsDepth",
    "filename": "transforms-depth.svg",
    "category": "interface",
    "tags": [
      "interface",
      "3d",
      "axis"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Transforms3dRotate",
    "filename": "transforms-3d-rotate.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "3d",
      "axis"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsVideo",
    "filename": "tools-video.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsVideoSmall",
    "filename": "tools-video-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsText",
    "filename": "tools-text.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsTextSmall",
    "filename": "tools-text-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsTextOnPath",
    "filename": "tools-text-on-path.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsTextOnPathSmall",
    "filename": "tools-text-on-path-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsStar",
    "filename": "tools-star.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsStarSmall",
    "filename": "tools-star-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsScale",
    "filename": "tools-scale.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "scale"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsScaleSmall",
    "filename": "tools-scale-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "scale"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsRectangle",
    "filename": "tools-rectangle.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsRectangleSmall",
    "filename": "tools-rectangle-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsPolygon",
    "filename": "tools-polygon.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsPolygonSmall",
    "filename": "tools-polygon-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsPencil",
    "filename": "tools-pencil.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsPencilSmall",
    "filename": "tools-pencil-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsPen",
    "filename": "tools-pen.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsPenSmall",
    "filename": "tools-pen-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsMove",
    "filename": "tools-move.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsMoveSmall",
    "filename": "tools-move-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsLine",
    "filename": "tools-line.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsLineSmall",
    "filename": "tools-line-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsKnife",
    "filename": "tools-knife.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsKnifeSmall",
    "filename": "tools-knife-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsImage",
    "filename": "tools-image.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsImageSmall",
    "filename": "tools-image-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsHand",
    "filename": "tools-hand.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsHandSmall",
    "filename": "tools-hand-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsFrame",
    "filename": "tools-frame.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "frame"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsFrameSmall",
    "filename": "tools-frame-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "frame"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsEllipse",
    "filename": "tools-ellipse.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsEllipseSmall",
    "filename": "tools-ellipse-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsAudio",
    "filename": "tools-audio.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsAudioSmall",
    "filename": "tools-audio-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolsArrow",
    "filename": "tools-arrow.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "ToolsArrowSmall",
    "filename": "tools-arrow-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Tools3d",
    "filename": "tools-3d.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "Tools3dSmall",
    "filename": "tools-3d-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarText",
    "filename": "toolbar-text.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "typography",
      "text",
      "input",
      "font",
      "paragraph",
      "format"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarStar",
    "filename": "toolbar-star.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape",
      "star"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarSelect",
    "filename": "toolbar-select.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "cursor",
      "arrow",
      "click",
      "mouse"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarScale",
    "filename": "toolbar-scale.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "scale",
      "right",
      "arrow",
      "zoom"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarRectangle",
    "filename": "toolbar-rectangle.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape",
      "rectangle",
      "square"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarPosition",
    "filename": "toolbar-position.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarPolygon",
    "filename": "toolbar-polygon.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "shape",
      "triangle"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarPenTool",
    "filename": "toolbar-pen-tool.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "signature",
      "pen",
      "edit",
      "sign",
      "pencil"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarLine",
    "filename": "toolbar-line.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "line",
      "divider"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarImage",
    "filename": "toolbar-image.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "image",
      "photo",
      "picture",
      "media",
      "graphic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarHand",
    "filename": "toolbar-hand.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "cursor",
      "grab",
      "hand",
      "hold"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarFrame",
    "filename": "toolbar-frame.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "design",
      "frame"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarEllipse",
    "filename": "toolbar-ellipse.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "circle",
      "radio",
      "shape"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarComponent",
    "filename": "toolbar-component.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "component",
      "widget"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarComment",
    "filename": "toolbar-comment.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarArrow",
    "filename": "toolbar-arrow.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "arrow",
      "top",
      "right",
      "forward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ToolbarAi",
    "filename": "toolbar-ai.svg",
    "category": "interface",
    "tags": [
      "interface",
      "toolbar",
      "ai",
      "integration",
      "extension",
      "sparkle",
      "magic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "TextOutline",
    "filename": "text-outline.svg",
    "category": "interface",
    "tags": [
      "variable",
      "interface",
      "typography",
      "text",
      "input",
      "font",
      "paragraph",
      "format",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Target",
    "filename": "target.svg",
    "category": "interface",
    "tags": [
      "interface",
      "target",
      "goals"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SubIndicatorDot",
    "filename": "sub-indicator-dot.svg",
    "category": "interface",
    "tags": [
      "interface",
      "solid",
      "dot"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Styles",
    "filename": "styles.svg",
    "category": "interface",
    "tags": [
      "interface",
      "app",
      "application",
      "dots",
      "circles"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StyleText",
    "filename": "style-text.svg",
    "category": "interface",
    "tags": [
      "interface",
      "typography",
      "text",
      "input",
      "font",
      "paragraph",
      "format"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StyleEffect",
    "filename": "style-effect.svg",
    "category": "interface",
    "tags": [
      "style",
      "effect",
      "flash",
      "interactive"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StyleColor",
    "filename": "style-color.svg",
    "category": "interface",
    "tags": [
      "style",
      "clone",
      "picker",
      "drop",
      "fill",
      "paint",
      "color",
      "design"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeTriangleArrow",
    "filename": "stroke-triangle-arrow.svg",
    "category": "interface",
    "tags": [
      "arrow",
      "line",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeReversedTriangle",
    "filename": "stroke-reversed-triangle.svg",
    "category": "interface",
    "tags": [
      "arrow",
      "line",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeOutside",
    "filename": "stroke-outside.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeOutline",
    "filename": "stroke-outline.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeLineArrow",
    "filename": "stroke-line-arrow.svg",
    "category": "interface",
    "tags": [
      "arrow",
      "line",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeInside",
    "filename": "stroke-inside.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeDiamondArrow",
    "filename": "stroke-diamond-arrow.svg",
    "category": "interface",
    "tags": [
      "arrow",
      "line",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeCircleArrow",
    "filename": "stroke-circle-arrow.svg",
    "category": "interface",
    "tags": [
      "arrow",
      "line",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StrokeCenter",
    "filename": "stroke-center.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Straight",
    "filename": "straight.svg",
    "category": "interface",
    "tags": [
      "stroke",
      "mirroring",
      "handle",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StickyTop",
    "filename": "sticky-top.svg",
    "category": "interface",
    "tags": [
      "interface",
      "upload",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StackRow",
    "filename": "stack-row.svg",
    "category": "interface",
    "tags": [
      "interface",
      "horizontal",
      "stack",
      "layout",
      "row"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StackRowWrap",
    "filename": "stack-row-wrap.svg",
    "category": "interface",
    "tags": [
      "interface",
      "stack",
      "layout",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StackColumn",
    "filename": "stack-column.svg",
    "category": "interface",
    "tags": [
      "interface",
      "vertical",
      "stack",
      "layout",
      "column"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StackColumnWrap",
    "filename": "stack-column-wrap.svg",
    "category": "interface",
    "tags": [
      "interface",
      "stack",
      "layout",
      "grid"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StabiliserWindow",
    "filename": "stabiliser-window.svg",
    "category": "interface",
    "tags": [
      "stroke",
      "brush",
      "pencil"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "StabiliserRope",
    "filename": "stabiliser-rope.svg",
    "category": "interface",
    "tags": [
      "stroke",
      "brush",
      "pencil"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SplitLayers",
    "filename": "split-layers.svg",
    "category": "interface",
    "tags": [
      "ai",
      "interface",
      "image"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SpanRow",
    "filename": "span-row.svg",
    "category": "interface",
    "tags": [
      "interface",
      "grid",
      "span"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SpanColumn",
    "filename": "span-column.svg",
    "category": "interface",
    "tags": [
      "interface",
      "grid",
      "span"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "SimplifyVector",
    "filename": "simplify-vector.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Rotate",
    "filename": "rotate.svg",
    "category": "interface",
    "tags": [
      "interface",
      "rotate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Rotate90Right",
    "filename": "rotate-90-right.svg",
    "category": "interface",
    "tags": [
      "interface",
      "process",
      "arrow",
      "refresh",
      "rotate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Relative",
    "filename": "relative.svg",
    "category": "interface",
    "tags": [
      "interface",
      "percent",
      "percentage",
      "relative",
      "finance"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RadiusTr",
    "filename": "radius-tr.svg",
    "category": "interface",
    "tags": [
      "interface",
      "radius",
      "rounded",
      "border",
      "top",
      "right"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RadiusTl",
    "filename": "radius-tl.svg",
    "category": "interface",
    "tags": [
      "interface",
      "radius",
      "rounded",
      "border",
      "top",
      "left"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RadiusBr",
    "filename": "radius-br.svg",
    "category": "interface",
    "tags": [
      "interface",
      "radius",
      "rounded",
      "border",
      "right",
      "bottom"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RadiusBl",
    "filename": "radius-bl.svg",
    "category": "interface",
    "tags": [
      "interface",
      "radius",
      "rounded",
      "border",
      "left",
      "bottom"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "RadiusAll",
    "filename": "radius-all.svg",
    "category": "interface",
    "tags": [
      "interface",
      "radius",
      "rounded",
      "border"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorWhiteBalance",
    "filename": "processor-white-balance.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorVignette",
    "filename": "processor-vignette.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorVibrance",
    "filename": "processor-vibrance.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorThreshold",
    "filename": "processor-threshold.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorSharpen",
    "filename": "processor-sharpen.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorPosterize",
    "filename": "processor-posterize.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorPhotoFilter",
    "filename": "processor-photo-filter.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorLevels",
    "filename": "processor-levels.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorInvert",
    "filename": "processor-invert.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorHueSaturation",
    "filename": "processor-hue-saturation.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorGradientMap",
    "filename": "processor-gradient-map.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorExposure",
    "filename": "processor-exposure.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorCurves",
    "filename": "processor-curves.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorColorBalance",
    "filename": "processor-color-balance.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorChannelMixer",
    "filename": "processor-channel-mixer.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorBrightnessContrast",
    "filename": "processor-brightness-contrast.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ProcessorBlackWhite",
    "filename": "processor-black-white.svg",
    "category": "interface",
    "tags": [
      "interface",
      "processor",
      "colors"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PreviewView",
    "filename": "preview-view.svg",
    "category": "interface",
    "tags": [
      "interface",
      "play",
      "start",
      "run",
      "video",
      "audio",
      "music",
      "arrow",
      "right",
      "next"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PanelTransparency",
    "filename": "panel-transparency.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelTransparencySmall",
    "filename": "panel-transparency-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PanelTransform",
    "filename": "panel-transform.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelTransformSmall",
    "filename": "panel-transform-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PanelStrokes",
    "filename": "panel-strokes.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelSelectionColors",
    "filename": "panel-selection-colors.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelSelectionColorsSmall",
    "filename": "panel-selection-colors-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PanelPage",
    "filename": "panel-page.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelLayout",
    "filename": "panel-layout.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelLayoutSmall",
    "filename": "panel-layout-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PanelLayoutGuides",
    "filename": "panel-layout-guides.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelLayer",
    "filename": "panel-layer.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelHelp",
    "filename": "panel-help.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelFills",
    "filename": "panel-fills.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelExport",
    "filename": "panel-export.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelExportSmall",
    "filename": "panel-export-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PanelEffects",
    "filename": "panel-effects.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelCharacter",
    "filename": "panel-character.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelBoolean",
    "filename": "panel-boolean.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelAppearance",
    "filename": "panel-appearance.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 24,
    "height": 24
  },
  {
    "name": "PanelAppearanceSmall",
    "filename": "panel-appearance-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "panel"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PaddingV",
    "filename": "padding-v.svg",
    "category": "interface",
    "tags": [
      "interface",
      "horizontal",
      "padding",
      "border"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PaddingT",
    "filename": "padding-t.svg",
    "category": "interface",
    "tags": [
      "interface",
      "top",
      "padding",
      "border"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PaddingR",
    "filename": "padding-r.svg",
    "category": "interface",
    "tags": [
      "interface",
      "right",
      "padding",
      "border"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PaddingPer",
    "filename": "padding-per.svg",
    "category": "interface",
    "tags": [
      "interface",
      "padding",
      "border"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PaddingL",
    "filename": "padding-l.svg",
    "category": "interface",
    "tags": [
      "interface",
      "left",
      "padding",
      "border"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PaddingH",
    "filename": "padding-h.svg",
    "category": "interface",
    "tags": [
      "interface",
      "vertical"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "PaddingB",
    "filename": "padding-b.svg",
    "category": "interface",
    "tags": [
      "interface",
      "bottom"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Opacity",
    "filename": "opacity.svg",
    "category": "interface",
    "tags": [
      "interface",
      "gradient",
      "opacity",
      "blur",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "OffsetVector",
    "filename": "offset-vector.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "NodesGroup",
    "filename": "nodes-group.svg",
    "category": "interface",
    "tags": [
      "interface",
      "group"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Mixed",
    "filename": "mixed.svg",
    "category": "interface",
    "tags": [
      "interface",
      "group"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MirroringNo",
    "filename": "mirroring-no.svg",
    "category": "interface",
    "tags": [
      "stroke",
      "mirroring",
      "handle",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MirroringAngle",
    "filename": "mirroring-angle.svg",
    "category": "interface",
    "tags": [
      "stroke",
      "mirroring",
      "handle",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MirroringAngleLength",
    "filename": "mirroring-angle-length.svg",
    "category": "interface",
    "tags": [
      "stroke",
      "mirroring",
      "handle",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MinimizeUi",
    "filename": "minimize-ui.svg",
    "category": "interface",
    "tags": [
      "interface",
      "dock"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MinWidth",
    "filename": "min-width.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "vertical",
      "collapse",
      "fold",
      "split"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MinHeight",
    "filename": "min-height.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "horizontal",
      "collapse",
      "fold",
      "split"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MaxWidth",
    "filename": "max-width.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "horizontal",
      "maximize"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "MaxHeight",
    "filename": "max-height.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "vertical",
      "maximize"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Mask",
    "filename": "mask.svg",
    "category": "interface",
    "tags": [
      "interface",
      "boolean",
      "group",
      "mask"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LockAspectRatio",
    "filename": "lock-aspect-ratio.svg",
    "category": "interface",
    "tags": [
      "interface",
      "link",
      "connection",
      "url",
      "hyperlink",
      "aspect"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ListFolder",
    "filename": "list-folder.svg",
    "category": "interface",
    "tags": [
      "interface",
      "folder",
      "directory",
      "folder-open",
      "folder-closed",
      "file",
      "catalog"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Letter",
    "filename": "letter.svg",
    "category": "interface",
    "tags": [
      "interface",
      "typography",
      "text",
      "input",
      "font",
      "paragraph",
      "format"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutRow",
    "filename": "layout-row.svg",
    "category": "interface",
    "tags": [
      "interface",
      "stack",
      "layout",
      "row",
      "horizontal"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "LayoutColumn",
    "filename": "layout-column.svg",
    "category": "interface",
    "tags": [
      "interface",
      "column",
      "vertical",
      "layout"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "JoinRound",
    "filename": "join-round.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "JoinMiter",
    "filename": "join-miter.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "JoinBevel",
    "filename": "join-bevel.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerWhilePressing",
    "filename": "interaction-trigger-while-pressing.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "dot"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerWhileHovering",
    "filename": "interaction-trigger-while-hovering.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "dot"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerOnDrag",
    "filename": "interaction-trigger-on-drag.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "interaction",
      "cursor"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerOnClick",
    "filename": "interaction-trigger-on-click.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "cursor",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerMouseUp",
    "filename": "interaction-trigger-mouse-up.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "arrow",
      "upload"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerMouseLeave",
    "filename": "interaction-trigger-mouse-leave.svg",
    "category": "interface",
    "tags": [
      "interface",
      "right",
      "arrow",
      "forward",
      "output",
      "export",
      "interaction"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerMouseEnter",
    "filename": "interaction-trigger-mouse-enter.svg",
    "category": "interface",
    "tags": [
      "interface",
      "right",
      "arrow",
      "forward",
      "input",
      "import",
      "interaction"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerMouseDown",
    "filename": "interaction-trigger-mouse-down.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerKeyGamepad",
    "filename": "interaction-trigger-key-gamepad.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionTriggerAfterDelay",
    "filename": "interaction-trigger-after-delay.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "clock",
      "day",
      "time",
      "watch",
      "stopwatch"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionNone",
    "filename": "interaction-none.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "circle",
      "cancel",
      "ban",
      "error",
      "slash",
      "wrong",
      "failure",
      "null"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionSwapOverlay",
    "filename": "interaction-action-swap-overlay.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "horizontal",
      "interaction"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionSetVariableMode",
    "filename": "interaction-action-set-variable-mode.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "photo",
      "image",
      "media",
      "picture",
      "gallery",
      "photography",
      "graphic",
      "paint",
      "palette",
      "color"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionScrollTo",
    "filename": "interaction-action-scroll-to.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionOpenOverlay",
    "filename": "interaction-action-open-overlay.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "add",
      "plus",
      "create",
      "new"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionNavigateTo",
    "filename": "interaction-action-navigate-to.svg",
    "category": "interface",
    "tags": [
      "interface",
      "horizontal",
      "arrow",
      "right",
      "next",
      "forward",
      "interaction"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionConditional",
    "filename": "interaction-action-conditional.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "branch",
      "split",
      "if",
      "logic",
      "git"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionCloseOverlay",
    "filename": "interaction-action-close-overlay.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "remove",
      "delete",
      "close"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionChangeTo",
    "filename": "interaction-action-change-to.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "loading",
      "loop",
      "process",
      "arrow",
      "refresh"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InteractionActionBack",
    "filename": "interaction-action-back.svg",
    "category": "interface",
    "tags": [
      "interface",
      "interaction",
      "arrow",
      "back",
      "backward"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InpaintPaint",
    "filename": "inpaint-paint.svg",
    "category": "interface",
    "tags": [
      "inpaint",
      "interface"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "InpaintEraser",
    "filename": "inpaint-eraser.svg",
    "category": "interface",
    "tags": [
      "inpaint",
      "interface"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageVectorize",
    "filename": "image-vectorize.svg",
    "category": "interface",
    "tags": [
      "image",
      "picture",
      "ai",
      "vector"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageSmall",
    "filename": "image-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "image",
      "photo",
      "picture",
      "media",
      "gallery",
      "graphic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageRemoveBackground",
    "filename": "image-remove-background.svg",
    "category": "interface",
    "tags": [
      "image",
      "picture",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageExpand",
    "filename": "image-expand.svg",
    "category": "interface",
    "tags": [
      "image",
      "picture",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageCrop",
    "filename": "image-crop.svg",
    "category": "interface",
    "tags": [
      "image",
      "picture"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ImageBoostResolution",
    "filename": "image-boost-resolution.svg",
    "category": "interface",
    "tags": [
      "image",
      "picture",
      "ai"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "HyperlinkBroken",
    "filename": "hyperlink-broken.svg",
    "category": "interface",
    "tags": [
      "interface",
      "link",
      "connection",
      "url",
      "hyperlink",
      "unlink",
      "remove",
      "broken"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "HugWidth",
    "filename": "hug-width.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "horizontal",
      "collapse",
      "fold"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "HugHeight",
    "filename": "hug-height.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "vertical",
      "collapse",
      "fold"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "House",
    "filename": "house.svg",
    "category": "interface",
    "tags": [
      "interface",
      "house",
      "home",
      "building"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Hidden",
    "filename": "hidden.svg",
    "category": "interface",
    "tags": [
      "interface",
      "view",
      "watch",
      "see",
      "show",
      "visibility",
      "visible",
      "preview",
      "read"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Grid",
    "filename": "grid.svg",
    "category": "interface",
    "tags": [
      "interface",
      "grid",
      "gallery",
      "boxes"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GapV",
    "filename": "gap-v.svg",
    "category": "interface",
    "tags": [
      "interface",
      "horizontal",
      "gap"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "GapH",
    "filename": "gap-h.svg",
    "category": "interface",
    "tags": [
      "interface",
      "vertical",
      "gap"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Frame",
    "filename": "frame.svg",
    "category": "interface",
    "tags": [
      "interface",
      "frame",
      "design",
      "tool"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FlipVertical",
    "filename": "flip-vertical.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "horizontal",
      "flip",
      "split"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FlipHorizontal",
    "filename": "flip-horizontal.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "vertical",
      "flip",
      "split"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FixedWidth",
    "filename": "fixed-width.svg",
    "category": "interface",
    "tags": [
      "interface",
      "horizontal",
      "maximize"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FixedHeight",
    "filename": "fixed-height.svg",
    "category": "interface",
    "tags": [
      "interface",
      "vertical"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FillWidth",
    "filename": "fill-width.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "horizontal",
      "maximize",
      "move"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FillHeight",
    "filename": "fill-height.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "vertical",
      "maximize",
      "move"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "FileSolid",
    "filename": "file-solid.svg",
    "category": "interface",
    "tags": [
      "interface",
      "solid",
      "folder",
      "directory",
      "folder-open",
      "folder-closed",
      "file",
      "catalog"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ExtractText",
    "filename": "extract-text.svg",
    "category": "interface",
    "tags": [
      "ai",
      "interface",
      "image"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Embed",
    "filename": "embed.svg",
    "category": "interface",
    "tags": [
      "interface",
      "code",
      "app",
      "development",
      "web"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Element",
    "filename": "element.svg",
    "category": "interface",
    "tags": [
      "interface",
      "square",
      "aspect",
      "rectangle",
      "shape",
      "boxes"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectsSettings",
    "filename": "effects-settings.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "theme",
      "weather",
      "sun"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectsGlass",
    "filename": "effects-glass.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "glass"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectNoise",
    "filename": "effect-noise.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "gradient",
      "opacity",
      "blur",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectLayerBlur",
    "filename": "effect-layer-blur.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "gradient",
      "opacity",
      "blur",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectInnerShadow",
    "filename": "effect-inner-shadow.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "shadow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectHalftone",
    "filename": "effect-halftone.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "gradient",
      "opacity",
      "blur",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectDropShadow",
    "filename": "effect-drop-shadow.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "shadow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EffectBackgroundBlur",
    "filename": "effect-background-blur.svg",
    "category": "interface",
    "tags": [
      "interface",
      "effect",
      "gradient",
      "opacity",
      "blur",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "EditObject",
    "filename": "edit-object.svg",
    "category": "interface",
    "tags": [
      "interface",
      "shape",
      "square",
      "line",
      "group",
      "path"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DynamicWiggle",
    "filename": "dynamic-wiggle.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DynamicSmoothen",
    "filename": "dynamic-smoothen.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DynamicFrequency",
    "filename": "dynamic-frequency.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DuplicateGroup",
    "filename": "duplicate-group.svg",
    "category": "interface",
    "tags": [
      "interface",
      "add",
      "plus",
      "create",
      "new",
      "paste",
      "clone",
      "copy",
      "duplicate"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Dimensional",
    "filename": "dimensional.svg",
    "category": "interface",
    "tags": [
      "interface",
      "3d",
      "axis",
      "shape",
      "cube"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "DimensionalTransforms",
    "filename": "dimensional-transforms.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "3d",
      "axis"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ComponentSolid",
    "filename": "component-solid.svg",
    "category": "interface",
    "tags": [
      "interface",
      "solid",
      "component",
      "widget"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ComponentOutline",
    "filename": "component-outline.svg",
    "category": "interface",
    "tags": [
      "interface",
      "component",
      "widget"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColorTypeSolid",
    "filename": "color-type-solid.svg",
    "category": "interface",
    "tags": [
      "interface",
      "color"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColorTypePattern",
    "filename": "color-type-pattern.svg",
    "category": "interface",
    "tags": [
      "interface",
      "color",
      "gradient",
      "opacity",
      "blur",
      "alpha",
      "pattern",
      "texture",
      "material"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColorTypeImage",
    "filename": "color-type-image.svg",
    "category": "interface",
    "tags": [
      "interface",
      "color",
      "image",
      "photo",
      "picture",
      "media",
      "gallery",
      "graphic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColorTypeGradient",
    "filename": "color-type-gradient.svg",
    "category": "interface",
    "tags": [
      "interface",
      "color",
      "gradient",
      "opacity",
      "blur",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColorOpacity",
    "filename": "color-opacity.svg",
    "category": "interface",
    "tags": [
      "interface",
      "color",
      "opacity",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ColorAlpha",
    "filename": "color-alpha.svg",
    "category": "interface",
    "tags": [
      "interface",
      "color",
      "opacity",
      "alpha"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Code",
    "filename": "code.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow",
      "enlarge",
      "horizontal",
      "move",
      "code"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CheckColorContrast",
    "filename": "check-color-contrast.svg",
    "category": "interface",
    "tags": [
      "interface",
      "color",
      "contrast",
      "adjust",
      "editor"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Centralize",
    "filename": "centralize.svg",
    "category": "interface",
    "tags": [
      "interface",
      "arrow"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CapSquare",
    "filename": "cap-square.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CapRound",
    "filename": "cap-round.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "CapButt",
    "filename": "cap-butt.svg",
    "category": "interface",
    "tags": [
      "interface",
      "path",
      "stroke"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "Border",
    "filename": "border.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderT",
    "filename": "border-t.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "top",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderSolid",
    "filename": "border-solid.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderR",
    "filename": "border-r.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "right",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderPer",
    "filename": "border-per.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderL",
    "filename": "border-l.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "left",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderDouble",
    "filename": "border-double.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderDotted",
    "filename": "border-dotted.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderDash",
    "filename": "border-dash.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BorderB",
    "filename": "border-b.svg",
    "category": "interface",
    "tags": [
      "interface",
      "border",
      "bottom",
      "divider",
      "alignment"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BooleanXor",
    "filename": "boolean-xor.svg",
    "category": "interface",
    "tags": [
      "interface",
      "boolean",
      "group",
      "path"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BooleanUnion",
    "filename": "boolean-union.svg",
    "category": "interface",
    "tags": [
      "interface",
      "boolean",
      "group",
      "path"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BooleanIntersection",
    "filename": "boolean-intersection.svg",
    "category": "interface",
    "tags": [
      "interface",
      "boolean",
      "group",
      "path"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BooleanDifference",
    "filename": "boolean-difference.svg",
    "category": "interface",
    "tags": [
      "interface",
      "boolean",
      "group",
      "path"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "BlendMode",
    "filename": "blend-mode.svg",
    "category": "interface",
    "tags": [
      "paint",
      "palette",
      "color"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AudioSmall",
    "filename": "audio-small.svg",
    "category": "interface",
    "tags": [
      "interface",
      "media"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ArtificialIntelligence",
    "filename": "artificial-intelligence.svg",
    "category": "interface",
    "tags": [
      "interface",
      "ai",
      "integration",
      "extension",
      "sparkle",
      "magic"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "ApplyVariable",
    "filename": "apply-variable.svg",
    "category": "interface",
    "tags": [
      "interface",
      "variable"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AiPaint",
    "filename": "ai-paint.svg",
    "category": "interface",
    "tags": [
      "inpaint",
      "interface"
    ],
    "width": 16,
    "height": 16
  },
  {
    "name": "AiEraser",
    "filename": "ai-eraser.svg",
    "category": "interface",
    "tags": [
      "inpaint",
      "interface"
    ],
    "width": 16,
    "height": 16
  }
];
